#
msgid ""
msgstr ""
"Project-Id-Version: \n"
"Report-Msgid-Bugs-To: \n"
"POT-Creation-Date: 2026-03-24 13:52+0200\n"
"PO-Revision-Date: \n"
"Last-Translator: \n"
"Language-Team: \n"
"Language: id\n"
"MIME-Version: 1.0\n"
"Content-Type: text/plain; charset=utf-8\n"
"Content-Transfer-Encoding: 8bit\n"
"Plural-Forms: \n"
"X-Generator: @lingui/cli\n"

#. placeholder {0}: item.maxSurge
#. placeholder {0}: item.maximum
#. placeholder {0}: item.minimum
#. placeholder {1}: item.maxSurge
#. placeholder {1}: item.maximum
#. placeholder {1}: item.minimum
#: src/modules/services/FailoverNodeSelect.tsx
#: src/modules/services/kubernetes/Infrastructure.tsx
#: src/modules/services/kubernetes/Infrastructure.tsx
#: src/modules/services/kubernetes/Infrastructure.tsx
#: src/modules/services/kubernetes/NodePoolsList.tsx
#: src/modules/services/kubernetes/NodePoolsList.tsx
#: src/modules/services/kubernetes/NodePoolsList.tsx
msgid "{0} {1, plural, one {node} other {nodes}}"
msgstr "{0} {1, plural, one {node} other {node}}"

#. placeholder {0}: uploadStats.uploadedFiles
#. placeholder {1}: uploadStats.totalFiles
#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "{0} of {1} files uploaded"
msgstr "{0} dari {1} file telah diunggah"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "{name} will be deleted permanently."
msgstr "{name} akan dihapus secara permanen."

#: src/modules/storage/StorageList.tsx
msgid "{number_of_buckets, plural, one {bucket} other {buckets}}"
msgstr "{number_of_buckets, plural, one {bucket} other {bucket}}"

#. {resourceTypeName} is eg. 'virtual machine' or 'billing account'
#: src/modules/api/resourceTypeException.tsx
msgid "{resourceTypeName} with ID {id} not found"
msgstr "{resourceTypeName} dengan ID {id} tidak ditemukan"

#. ONLY:bn
#: src/styles/tenbyte/theme.tsx
msgid "<0><1>Individual/Proprietor: NID, Passport, or Driver's License.</1><2>Company/Corporate: Trade License.</2><3>Financial & Legal: Tax Identification Number (TIN), VAT Certificate.</3></0>"
msgstr ""

#: src/modules/billing/LimitedBillingAccountNotice.tsx
msgid "1 bare metal server"
msgstr "1 server bare metal"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "1 day"
msgstr "1 hari"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "1 hour"
msgstr "1 jam"

#: src/modules/billing/omise/OmisePaymentForm.tsx
msgid "10 digit TrueMoney mobile number starting with 0"
msgstr "Nomor ponsel TrueMoney 10 digit yang diawali dengan 0"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "3 days"
msgstr "3 hari"

#: src/modules/compute/VmView.tsx
msgid "4 weeks"
msgstr "4 minggu"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "6 hours"
msgstr "6 jam"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "7 days"
msgstr "7 hari"

#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "A discount has been applied for all services under this billing account."
msgstr "Diskon telah diterapkan untuk semua layanan di bawah akun penagihan ini."

#: src/modules/compute/VmCreate.tsx
msgid "A user account will be created with this username. It can be used to log in to the VM. Can contain ASCII letters, digits, underscores and hyphens. Must start with a letter or underscore. Maximum length is 25 characters."
msgstr "Akun pengguna akan dibuat dengan nama pengguna ini. Akun tersebut dapat digunakan untuk masuk ke VM. Dapat berisi huruf ASCII, angka, garis bawah, dan tanda hubung. Harus diawali dengan huruf atau garis bawah. Panjang maksimum adalah 25 karakter."

#: src/modules/network/NetworkCreate.tsx
msgid "A virtual private cloud (VPC) is a private network interface for collections of your resources. VPC network is available at no additional cost."
msgstr "Virtual private cloud (VPC) adalah antarmuka jaringan privat untuk kumpulan sumber daya Anda. Jaringan VPC tersedia tanpa biaya tambahan."

#: src/modules/access/AcceptInvitationModal.tsx
#: src/modules/access/AcceptInvitationModal.tsx
msgid "Accept"
msgstr "Terima"

#: src/modules/access/AcceptInvitationModal.tsx
msgid "Accept invitation"
msgstr "Terima undangan"

#: src/modules/access/delegation/DelegationView.tsx
#: src/modules/dashboard/RecentlyModified.tsx
#: src/modules/dashboard/RecentlyModified.tsx
#: src/modules/user/ProfileView.tsx
msgid "Accepted"
msgstr "Diterima"

#: src/modules/access/AcceptInvitationModal.tsx
msgid "Accepting this access invitation will grant you permission to act as \"{name}\" and perform all operations on behalf of the user."
msgstr "Menerima undangan akses ini akan memberi Anda izin untuk bertindak sebagai \"{name}\" dan melakukan semua operasi atas nama pengguna."

#. Label for dropdown menu that has options related to file sharing and permissions. | POS: Noun
#. Title for section that contains credentials to connect to a database
#: src/modules/access/AccessList.tsx
#: src/modules/api/resourceTypes.tsx
#: src/modules/main/sidebar/Sidebar.sections.tsx
#: src/modules/services/Access.tsx
#: src/modules/services/ServiceView.tsx
#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Access"
msgstr "Akses"

#: src/modules/metal/MetalLeaseDetailView.tsx
msgid "Access credentials"
msgstr "Kredensial akses"

#: src/modules/api/resourceTypes.tsx
msgid "Access delegation"
msgstr "Delegasi akses"

#: src/modules/user/ProfileView.tsx
msgid "Access group"
msgstr "Grup akses"

#: src/modules/user/InvitationNotice.tsx
msgid "Access has been shared with you"
msgstr "Akses telah dibagikan kepada Anda"

#: src/modules/api/resourceTypes.tsx
msgid "Access invitation"
msgstr "Undangan akses"

#. placeholder {0}: item.access_owner
#: src/modules/user/InvitationNotice.tsx
msgid "Access invitation from {0} is pending"
msgstr "Undangan akses dari {0} sedang menunggu"

#: src/modules/storage/account/StorageAccountView.tsx
msgid "Access key ID"
msgstr "ID kunci akses"

#: src/modules/access/AccessCreate.tsx
#: src/modules/access/delegation/DelegationView.tsx
#: src/modules/access/token/TokenView.tsx
msgid "Access name"
msgstr "Nama akses"

#: src/modules/access/delegation/DelegationView.tsx
#: src/modules/access/token/TokenView.tsx
#: src/modules/user/ProfileView.tsx
msgid "Access scope"
msgstr "Cakupan akses"

#: src/modules/access/delegation/DelegationView.tsx
#: src/modules/access/token/TokenView.tsx
msgid "Access type"
msgstr "Jenis akses"

#. Dialog title
#: src/modules/user/ActAsModal.tsx
msgid "Access user"
msgstr "Akses pengguna"

#: src/modules/billing/account_validation/BillingAccountValidationBlock.tsx
#: src/modules/billing/NoValidBillingAccountNotice.tsx
#: src/modules/dashboard/BillingAccounts.tsx
msgid "Account details are being validated."
msgstr "Detail akun sedang divalidasi."

#: src/modules/billing/account_validation/GeneralBaValidationBlock.tsx
msgid "Account details must be validated"
msgstr "Detail akun harus divalidasi"

#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "Account ID"
msgstr "ID akun"

#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/dashboard/BillingAccounts.tsx
msgid "Account name"
msgstr "Nama akun"

#. Menu item to impersonate another user
#: src/modules/user/ActAsModal.tsx
#: src/modules/user/UserMenu.tsx
msgid "Act as"
msgstr "Bertindak sebagai"

#. placeholder {0}: impersonation.access_owner
#: src/modules/user/ImpersonateTopItem.tsx
msgid "Acting as <0>{0}</0>"
msgstr "Bertindak sebagai <0>{0}</0>"

#. Login page title when email verification is required
#: src/modules/login/auth0/Auth0Login.tsx
msgid "Action required"
msgstr "Tindakan diperlukan"

#. Billing account status
#. Disk status
#. Service status
#: src/modules/billing/statusHistory/statusHistoryLabels.tsx
#: src/modules/compute/statusLabels.tsx
#: src/modules/disks/DiskStatusBadge.tsx
msgid "Active"
msgstr "Aktif"

#: src/modules/storage/StorageCreate.tsx
msgid "Actual cost of your storage is calculated hourly based on your actual usage, no upfront payments. For every started GB the price is rounded up to next whole GB."
msgstr "Biaya aktual penyimpanan Anda dihitung per jam berdasarkan penggunaan aktual, tanpa pembayaran di muka. Untuk setiap GB yang mulai digunakan, harga dibulatkan ke atas ke GB utuh berikutnya."

#: src/modules/services/ServiceView.tsx
msgid "Actual price is determined by compute and storage usage. Persistent volumes of hibernated clusters will still be charged for. See billing account current usage for more detailed information."
msgstr "Harga sebenarnya ditentukan oleh penggunaan komputasi dan penyimpanan. Volume persisten pada cluster yang dihibernasikan akan tetap dikenakan biaya. Lihat penggunaan saat ini pada akun penagihan untuk informasi yang lebih rinci."

#. Add a new row; Button action
#: src/components/EditableList.tsx
#: src/modules/billing/choose_method/AddPaymentMethodModal.tsx
#: src/modules/compute/AddFirewallForm.tsx
#: src/modules/compute/AddSshKeyModal.tsx
#: src/modules/compute/AddSubInterfaceModal.tsx
#: src/modules/compute/DiskAddOrResizeModal.tsx
#: src/modules/metal/commitment/AddCommitmentModal.tsx
#: src/modules/network/firewall/AddResourceForm.tsx
#: src/modules/network/firewall/EditRuleModal.tsx
#: src/modules/network/loadbalancer/AddForwardingRuleForm.tsx
#: src/modules/network/loadbalancer/AddTargetServerForm.tsx
#: src/modules/services/AddIpForm.tsx
#: src/modules/services/kubernetes/NodeResizeModal.tsx
msgid "Add"
msgstr "Tambah"

#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "Add a a payment method that supports automated top up."
msgstr "Tambahkan metode pembayaran yang mendukung isi saldo otomatis."

#: src/modules/compute/DiskAddOrResizeModal.tsx
#: src/modules/compute/VmView.tsx
msgid "Add additional disk"
msgstr "Tambah disk tambahan"

#: src/modules/network/NetworkCreate.tsx
msgid "Add at least one forwarding rule"
msgstr "Tambahkan setidaknya satu aturan penerusan"

#: src/modules/network/NetworkCreate.tsx
msgid "Add at least one target server"
msgstr "Tambahkan setidaknya satu server target"

#: src/modules/compute/VmCreate.tsx
msgid "Add custom configuration for the virtual machine"
msgstr "Tambahkan konfigurasi khusus untuk mesin virtual"

#: src/modules/user/ProfileView.tsx
msgid "Add first name"
msgstr "Tambahkan nama depan"

#: src/modules/services/IpWhitelist.tsx
msgid "Add IP"
msgstr "Tambahkan IP"

#: src/modules/user/ProfileView.tsx
msgid "Add last name"
msgstr "Tambahkan nama belakang"

#: src/components/table/DetailsTableName.tsx
msgid "Add name"
msgstr "Tambahkan nama"

#: src/modules/billing/payment/PaymentModal.tsx
msgid "Add new payment method..."
msgstr "Tambahkan metode pembayaran baru..."

#: src/modules/metal/commitment/AddCommitmentModal.tsx
msgid "Add new reservation"
msgstr "Tambahkan reservasi baru"

#: src/modules/network/firewall/RulesList.tsx
#: src/modules/network/loadbalancer/ForwardingRulesList.tsx
#: src/modules/network/loadbalancer/LoadBalancerView.tsx
msgid "Add new rule"
msgstr "Tambah aturan baru"

#: src/modules/services/kubernetes/NodeResizeModal.tsx
msgid "Add node"
msgstr "Tambah node"

#: src/modules/services/kubernetes/Infrastructure.tsx
#: src/modules/services/kubernetes/NodePoolsList.tsx
msgid "Add node pool"
msgstr "Tambah node pool"

#: src/modules/billing/ActionButtons.tsx
#: src/modules/billing/billingAccount/BillingCreate.tsx
#: src/modules/billing/BillingAccountInfo.tsx
#: src/modules/billing/choose_method/AddPaymentMethodModal.tsx
#: src/modules/billing/payment/PaymentModal.tsx
msgid "Add payment method"
msgstr "Tambahkan metode pembayaran"

#: src/modules/billing/billingAccount/BillingCreate.tsx
msgid "Add payment method later"
msgstr "Tambahkan metode pembayaran nanti"

#: src/modules/network/firewall/EditRuleModal.tsx
#: src/modules/network/firewall/FirewallView.tsx
msgid "Add rule"
msgstr "Tambah aturan"

#: src/modules/compute/AddSshKeyModal.tsx
#: src/modules/compute/VmCreate.tsx
msgid "Add SSH key"
msgstr "Tambah kunci SSH"

#: src/modules/compute/AddSubInterfaceModal.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/compute/VmView.tsx
msgid "Add sub-interface"
msgstr "Tambah subinterface"

#: src/modules/network/loadbalancer/LoadBalancerView.tsx
msgid "Add target server"
msgstr "Tambah server target"

#: src/modules/access/delegation/AddImpersonationForm.tsx
msgid "Add user"
msgstr "Tambah pengguna"

#: src/modules/access/delegation/DelegationView.tsx
msgid "Add users"
msgstr "Tambah pengguna"

#: src/modules/billing/choose_method/useAddMethod.tsx
msgid "Adding payment method failed"
msgstr "Gagal menambahkan metode pembayaran"

#: src/modules/billing/billingAccount/BillingCreate.tsx
#: src/modules/network/NetworkList.tsx
msgid "Address"
msgstr "Alamat"

#: src/modules/billing/billingAccount/fieldsInfo.tsx
msgid "Address line 2"
msgstr "Baris alamat 2"

#. Link to administrative user interface
#: src/modules/user/UserMenu.tsx
msgid "Admin view"
msgstr "Tampilan admin"

#. Who changed the billing account status
#: src/modules/billing/statusHistory/statusHistoryLabels.tsx
msgid "Administrator"
msgstr ""

#. What caused the billing account status change
#: src/modules/billing/statusHistory/statusHistoryLabels.tsx
msgid "Administrator action"
msgstr ""

#: src/components/table/DetailsTableBillingAccount.tsx
#: src/components/WTabs.tsx
msgid "All"
msgstr "Semua"

#. A firewall rule that applies to every source or destination IP address
#: src/modules/network/firewall/firewallLabels.tsx
msgid "All IP addresses"
msgstr "Semua alamat IP"

#: src/modules/storage/account/StorageAccountView.tsx
msgid "All permissions"
msgstr "Semua izin"

#: src/modules/network/firewall/ruleSpec.tsx
msgid "All TCP"
msgstr "Semua TCP"

#: src/modules/network/firewall/ruleSpec.tsx
msgid "All UDP"
msgstr "Semua UDP"

#: src/modules/api/resourceTypes.tsx
msgid "Allocate a floating IP and start managing your network."
msgstr "Alokasikan Floating IP dan mulai kelola jaringan Anda."

#. Metal commitment status
#: src/modules/metal/statusLabels.tsx
msgid "Allocated"
msgstr "Dialokasikan"

#: src/modules/network/NetworkCreate.tsx
msgid "Allocating a new IPv4 address allows you to assign it to one of your existing resources or reserve it for later use."
msgstr "Mengalokasikan alamat IPv4 baru memungkinkan Anda menetapkannya ke salah satu sumber daya yang sudah ada atau mencadangkannya untuk digunakan nanti."

#: src/modules/login/Login.tsx
msgid "Already have an account?"
msgstr "Sudah punya akun?"

#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/invoice/InvoiceView.tsx
msgid "Amount"
msgstr "Jumlah"

#. Field label for reservation upfront cost
#: src/modules/metal/offer/MetalOfferSection.tsx
msgid "Amount billed upfront"
msgstr "Jumlah yang ditagihkan di muka"

#: src/modules/billing/payment/PaymentModal.tsx
msgid "Amount is too low"
msgstr "Jumlah terlalu kecil"

#: src/modules/billing/AutomatedTopUpModal.tsx
#: src/modules/billing/LowBalanceNotificationsModal.tsx
msgid "Amount should be positive"
msgstr "Jumlah harus lebih besar dari nol"

#: src/modules/billing/AutomatedTopUpModal.tsx
msgid "Amount should not be less than than minimum top up"
msgstr "Jumlah tidak boleh kurang dari minimum isi saldo"

#: src/modules/billing/NoValidBillingAccountNotice.tsx
msgid "An active billing account is needed to create resources."
msgstr "Akun penagihan aktif diperlukan untuk membuat resource."

#: src/modules/billing/referral/ReferralProgram.tsx
msgid "An active billing account is needed to use this feature."
msgstr "Akun penagihan aktif diperlukan untuk menggunakan fitur ini."

#: src/modules/billing/account_validation/BillingAccountValidationBlock.tsx
msgid "An e-mail with instructions has been sent to you."
msgstr "E-mail berisi petunjuk telah dikirim kepada Anda."

#: src/components/modal/WModal.tsx
#: src/components/sidebar/ListErrorBoundary.tsx
msgid "An error happened"
msgstr "Terjadi kesalahan"

#: src/modules/network/firewall/EditRuleModal.tsx
#: src/modules/network/firewall/FirewallView.tsx
#: src/modules/network/firewall/RulesList.tsx
#: src/modules/network/firewall/ruleSpec.tsx
#: src/modules/network/firewall/ruleSpec.tsx
msgid "Any"
msgstr "Apa pun"

#: src/modules/access/AccessList.tsx
#: src/modules/dashboard/WelcomeBlock.tsx
#: src/modules/services/kubernetes/KubernetesReadynessBadge.tsx
msgid "API"
msgstr "API"

#: src/modules/dashboard/WelcomeBlock.tsx
msgid "API documentation"
msgstr "Dokumentasi API"

#: src/modules/api/resourceTypes.tsx
msgid "API token"
msgstr "Token API"

#: src/modules/compute/labels.tsx
#: src/modules/dashboard/StartSomethingNew.tsx
msgid "App catalog"
msgstr "Katalog aplikasi"

#: src/modules/main/ColorSchemeMenu.tsx
msgid "Appearance"
msgstr "Tampilan"

#: src/modules/billing/billingAccount/BillingCreate.tsx
msgid "Apply for payment by invoice"
msgstr "Ajukan pembayaran dengan faktur"

#: src/modules/compute/SubInterfaceDeleteModal.tsx
msgid "Are you sure you want to delete sub-interface with uuid {ifUuid}?"
msgstr "Apakah Anda yakin ingin menghapus subinterface dengan UUID {ifUuid}?"

#: src/modules/compute/SshKeyDeleteModal.tsx
msgid "Are you sure you want to delete the public key \"{name}\"?"
msgstr "Apakah Anda yakin ingin menghapus kunci publik \"{name}\"?"

#: src/modules/main/LogoutConfirmDialog.tsx
msgid "Are you sure you want to log out?"
msgstr "Apakah Anda yakin ingin keluar?"

#: src/modules/network/NetworkCreate.tsx
msgid "Assign to"
msgstr "Tetapkan ke"

#. State of IP address, attached to a resource such as a virtual machine
#: src/modules/dashboard/RecentlyModified.tsx
#: src/modules/network/CreateAndAssignIpField.tsx
#: src/modules/network/ipAddress/IpAddressView.tsx
#: src/modules/network/NetworkList.tsx
msgid "Assigned"
msgstr "Ditetapkan"

#: src/modules/network/ipAddress/IpAddressView.tsx
#: src/modules/network/NetworkCreate.tsx
msgid "Assigned to"
msgstr "Ditetapkan ke"

#: src/modules/access/AccessCreate.tsx
msgid "At least one email is required"
msgstr "Setidaknya satu email diperlukan"

#: src/modules/network/firewall/EditRuleModal.tsx
msgid "At least one IP is required"
msgstr "Setidaknya satu IP diperlukan"

#: src/modules/services/kubernetes/NodeResizeModal.tsx
msgid "At least one node pool must have autoscaler minimum value as 1 or more."
msgstr "Setidaknya satu node pool harus memiliki nilai minimum autoskaler 1 atau lebih."

#: src/modules/compute/VmView.tsx
msgid "Attach firewall"
msgstr "Lampirkan firewall"

#: src/modules/network/firewall/FirewallView.tsx
msgid "Attach resource"
msgstr "Lampirkan resource"

#: src/modules/disks/DiskList.tsx
msgid "Attached"
msgstr "Terpasang"

#: src/modules/disks/disk/DiskView.tsx
#: src/modules/disks/DiskCreate.tsx
msgid "Attached to"
msgstr "Terpasang pada"

#. Explanation: Switching the color schema automatically. |Alternatives: 'Automatic'
#: src/modules/main/ColorSchemeMenu.tsx
msgid "Auto"
msgstr "Otomatis"

#: src/modules/services/kubernetes/MaintenanceEditModal.tsx
msgid "Auto update"
msgstr "Pembaruan otomatis"

#: src/modules/dashboard/BillingAccounts.tsx
msgid "Automated payment"
msgstr "Pembayaran otomatis"

#: src/modules/billing/AutomatedTopUpModal.tsx
#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "Automated top up"
msgstr "Isi saldo otomatis"

#: src/modules/services/Backups.tsx
#: src/modules/services/kubernetes/Maintenance.tsx
msgid "Automatic system-level backups are enabled. Use the backup images to restore your service. Backups will be stored for 7 days, meaning you will have 7 latest backups."
msgstr "Backup tingkat sistem otomatis diaktifkan. Gunakan image backup untuk memulihkan layanan Anda. Backup akan disimpan selama 7 hari, yang berarti Anda akan memiliki 7 backup terbaru."

#: src/modules/compute/VmView.tsx
msgid "Automatic system-level backups are enabled. Use the backup images to restore your virtual machine or create a new virtual machine from the backup with modified size parameters."
msgstr "Cadangan otomatis tingkat sistem diaktifkan. Gunakan image cadangan untuk memulihkan mesin virtual Anda atau membuat mesin virtual baru dari cadangan dengan parameter ukuran yang diubah."

#: src/modules/services/kubernetes/MaintenanceEditModal.tsx
msgid "Automatic updates will not update preview versions."
msgstr "Pembaruan otomatis tidak akan memperbarui versi pratinjau."

#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "Automatically top up (min. <0/>)"
msgstr "Isi saldo otomatis (min. <0/>)"

#: src/modules/services/kubernetes/Infrastructure.tsx
#: src/modules/services/kubernetes/NodePoolsList.tsx
#: src/modules/services/kubernetes/NodeResizeModal.tsx
msgid "Autoscaler max."
msgstr "Maks. autoskaler"

#: src/modules/services/kubernetes/Infrastructure.tsx
#: src/modules/services/kubernetes/NodePoolsList.tsx
#: src/modules/services/kubernetes/NodeResizeModal.tsx
msgid "Autoscaler min."
msgstr "Min. autoskaler"

#: src/modules/metal/status/StatusLabels.tsx
msgid "Available"
msgstr "Tersedia"

#: src/modules/services/ServiceView.tsx
msgid "Awake"
msgstr "Aktif"

#. Button action
#: src/modules/login/auth0/Auth0Login.tsx
#: src/modules/login/Login.tsx
msgid "Back"
msgstr "Kembali"

#: src/modules/user/ImpersonateTopItem.tsx
#: src/modules/user/UserMenu.tsx
msgid "Back to your account"
msgstr "Kembali ke akun Anda"

#: src/modules/compute/VmView.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/services/Backups.tsx
#: src/modules/services/ServiceView.tsx
msgid "Backups"
msgstr "Backup"

#. Table column: billing account balance when the change happened
#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "Balance"
msgstr ""

#: src/modules/billing/statusHistory/statusHistoryLabels.tsx
msgid "Balance became negative"
msgstr ""

#: src/modules/billing/statusHistory/StatusHistory.tsx
#: src/modules/billing/statusHistory/statusHistoryLabels.tsx
msgid "Balance became positive"
msgstr ""

#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "Balance history"
msgstr "Riwayat saldo"

#: src/modules/billing/statusHistory/StatusHistory.tsx
msgid "Balance negative for {days, plural, one {# day} other {# days}} (limit: {threshold, plural, one {# day} other {# days}})"
msgstr ""

#: src/modules/billing/statusHistory/StatusHistory.tsx
msgid "Balance negative for too long"
msgstr ""

#: src/modules/main/sidebar/Sidebar.sections.tsx
#: src/modules/metal/MetalList.tsx
msgid "Bare metal"
msgstr "Bare metal"

#: src/modules/api/resourceTypes.tsx
msgid "Bare metal server"
msgstr "Server bare metal"

#: src/modules/billing/BaseCurrencyField.tsx
#: src/modules/billing/CurrencyPaymentFees.tsx
msgid "Base currency"
msgstr "Mata uang dasar"

#: src/modules/billing/account_validation/digio/DigioBaValidationBlock.tsx
msgid "Begin your billing account validation process."
msgstr "Mulai proses validasi akun penagihan Anda."

#: src/modules/compute/SubInterfaceModal.tsx
msgid "Below is an example of how to configure this sub-interface on a Linux server."
msgstr "Berikut adalah contoh cara mengonfigurasi subinterface ini pada server Linux."

#: src/modules/billing/statusHistory/StatusHistory.tsx
msgid "Below the top-up threshold"
msgstr ""

#. Metal commitment status
#: src/modules/metal/statusLabels.tsx
msgid "Billed"
msgstr "Ditagihkan"

#: src/modules/api/resourceTypes.tsx
#: src/modules/billing/BillingList.tsx
#: src/modules/main/sidebar/Sidebar.sections.tsx
msgid "Billing"
msgstr "Penagihan"

#: src/components/table/DetailsTableBillingAccount.tsx
#: src/components/table/DetailsTableBillingAccount.tsx
#: src/modules/api/resourceTypes.tsx
#: src/modules/billing/forms/BillingAccountField.tsx
#: src/modules/billing/invoice/InvoiceView.tsx
#: src/modules/billing/invoice/InvoiceView.tsx
#: src/modules/billing/referral/ReferralProgram.tsx
msgid "Billing account"
msgstr "Akun penagihan"

#. Price list annotation
#: src/modules/pricing/PricingModal.tsx
msgid "Billing account \"{title}\" has discount {discount_percentage}%"
msgstr "Akun penagihan \"{title}\" memiliki diskon {discount_percentage}%"

#: src/modules/billing/statusHistory/statusHistoryLabels.tsx
msgid "Billing account created"
msgstr ""

#: src/modules/billing/statusHistory/StatusHistory.tsx
#: src/modules/billing/statusHistory/statusHistoryLabels.tsx
msgid "Billing account deleted"
msgstr ""

#: src/modules/billing/LimitedBillingAccountNotice.tsx
msgid "Billing account is limited"
msgstr "Akun penagihan terbatas"

#: src/modules/billing/billingAccount/fieldsInfo.tsx
msgid "Billing account name"
msgstr "Nama akun penagihan"

#: src/modules/storage/account/StorageAccountView.tsx
msgid "Billing account override"
msgstr "Penggantian akun penagihan"

#: src/modules/billing/statusHistory/statusHistoryLabels.tsx
msgid "Billing account reactivated"
msgstr ""

#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/statusHistory/StatusHistory.tsx
#: src/modules/billing/statusHistory/statusHistoryLabels.tsx
msgid "Billing account suspended"
msgstr "Akun penagihan ditangguhkan"

#: src/modules/billing/statusHistory/statusHistoryLabels.tsx
msgid "Billing account updated"
msgstr ""

#. What caused the billing account status change
#: src/modules/billing/statusHistory/statusHistoryLabels.tsx
msgid "Billing account validation"
msgstr ""

#: src/modules/billing/account_validation/digio/DigioBaValidationBlock.tsx
msgid "Billing account validation was rejected"
msgstr "Validasi akun penagihan ditolak"

#: src/modules/billing/statusHistory/StatusHistory.tsx
msgid "Billing account waiting for validation"
msgstr ""

#: src/modules/dashboard/BillingAccounts.tsx
msgid "Billing accounts"
msgstr "Akun penagihan"

#: src/modules/metal/MetalLeaseDetailView.tsx
#: src/modules/metal/offer/MetalOfferSection.tsx
msgid "Billing cycle"
msgstr "Siklus penagihan"

#: src/modules/disks/disk/DiskView.tsx
msgid "Boot"
msgstr "Boot"

#: src/modules/compute/BootFromIsoModal.tsx
msgid "Boot from ISO medium"
msgstr "Boot dari media ISO"

#. Virtual machine choice: UEFI or BIOS
#: src/modules/compute/VmCreate.tsx
#: src/modules/compute/VmView.tsx
msgid "Boot mode"
msgstr "Mode boot"

#: src/modules/compute/BootFromIsoModal.tsx
msgid "Booting is only possible when the virtual machine is stopped."
msgstr "Boot hanya dapat dilakukan saat mesin virtual dihentikan."

#. {payment method} provided by {payment gateway name}
#: src/modules/billing/utils.tsx
msgid "by {gatewayName}"
msgstr "oleh {gatewayName}"

#: src/modules/billing/sslcommerz/SslcommerzPaymentForm.tsx
msgid "By continuing with the top up you agree to the <0>Terms & Conditions</0>, <1>Privacy Policy</1> & <2>Refund Policy</2>."
msgstr "Dengan melanjutkan isi saldo, Anda menyetujui <0>Syarat & Ketentuan</0>, <1>Kebijakan Privasi</1>, dan <2>Kebijakan Pengembalian Dana</2>."

#: src/modules/compute/VmView.tsx
msgid "By disabling backups there will not be any further automatic backups made from your virtual machine. Backups done by this point will be kept as is and you can still use them. You can enable backups again whenever needed."
msgstr "Dengan menonaktifkan backup, tidak akan ada lagi backup otomatis yang dibuat dari mesin virtual Anda. Backup yang sudah dibuat hingga saat ini akan tetap disimpan sebagaimana adanya dan Anda masih dapat menggunakannya. Anda dapat mengaktifkan kembali backup kapan pun diperlukan."

#: src/modules/access/AccessCreate.tsx
msgid "By selecting “Global”, all resources under this user account can be accessed. Exercise caution when selecting “Global” scope."
msgstr "Dengan memilih “Global”, semua sumber daya di bawah akun pengguna ini dapat diakses. Berhati-hatilah saat memilih cakupan “Global”."

#: src/modules/access/AccessCreate.tsx
msgid "By selecting “Restricted”, access will be limited to resources belonging to the selected billing account."
msgstr "Dengan memilih “Terbatas”, akses akan dibatasi pada sumber daya yang dimiliki oleh akun penagihan yang dipilih."

#: src/modules/login/auth0/Auth0Login.tsx
msgid "By signing up, you agree to the <0>Terms of Service</0>"
msgstr "Dengan mendaftar, Anda menyetujui <0>Syarat dan Ketentuan Layanan</0>"

#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/billingAccount/fieldsInfo.tsx
msgid "Campaign code"
msgstr "Kode kampanye"

#: src/modules/dashboard/UserAccess.tsx
msgid "Can access me"
msgstr "Akses diberikan"

#: src/modules/billing/billingAccount/BillingCreate.tsx
#: src/modules/billing/billingAccount/BillingCreate.tsx
msgid "Cancel"
msgstr "Batal"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Cancel uploads"
msgstr "Batalkan unggahan"

#. Metal commitment status
#: src/modules/metal/statusLabels.tsx
msgid "Cancelled"
msgstr "Dibatalkan"

#: src/modules/billing/payment_forms/labels.tsx
msgid "Card number"
msgstr "Nomor kartu"

#: src/modules/billing/omise/parseOmisePersistentData.ts
msgid "Card verification failed"
msgstr "Verifikasi kartu gagal"

#: src/modules/compute/ChangePasswordModal.tsx
msgid "Change"
msgstr "Ubah"

#: src/modules/compute/ChangePasswordModal.tsx
#: src/modules/compute/ChangePasswordModal.tsx
msgid "Change password"
msgstr "Ubah kata sandi"

#: src/modules/login/Login.tsx
msgid "Change your password by clicking the verification link we just sent to your inbox."
msgstr "Ubah kata sandi Anda dengan mengeklik tautan verifikasi yang baru saja kami kirim ke kotak masuk Anda."

#. Table column: who changed the billing account status
#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "Changed by"
msgstr ""

#: src/modules/user/ProfileView.tsx
msgid "Changing the password failed"
msgstr "Gagal mengubah kata sandi"

#: src/modules/compute/ChangePasswordModal.tsx
msgid "Changing the password is only possible when the virtual machine is running."
msgstr "Perubahan kata sandi hanya dapat dilakukan saat mesin virtual sedang berjalan."

#: src/modules/billing/forms/BillingAccountField.tsx
msgid "Choose a billing account for your new resource to consolidate your resources under a suitable payment method."
msgstr "Pilih akun penagihan untuk sumber daya baru Anda agar sumber daya Anda dapat digabungkan dalam metode pembayaran yang sesuai."

#: src/modules/access/AccessCreate.tsx
msgid "Choose a billing account you wish to share access to"
msgstr "Pilih akun penagihan yang ingin Anda bagikan aksesnya"

#: src/modules/network/NetworkCreate.tsx
msgid "Choose a resource to assign the IP to or leave it unassigned. You can always assign the IP to a suitable resource later"
msgstr "Pilih sumber daya untuk menetapkan IP atau biarkan tidak ditetapkan. Anda selalu dapat menetapkan IP ke sumber daya yang sesuai nanti"

#: src/modules/disks/DiskCreate.tsx
msgid "Choose a virtual machine to attach the disk to, or leave it detached and connect it to a virtual machine later."
msgstr "Pilih virtual machine untuk memasang disk, atau biarkan disk tidak terpasang dan hubungkan ke virtual machine nanti."

#: src/modules/compute/VmCreate.tsx
#: src/modules/services/ServiceCreate.tsx
msgid "Choose a VPC network for your resource from already existing one or create a new private network."
msgstr "Pilih jaringan VPC untuk resource Anda dari yang sudah ada atau buat jaringan privat baru."

#: src/modules/billing/referral/ReferralProgram.tsx
msgid "Choose billing account"
msgstr "Pilih akun penagihan"

#: src/modules/billing/billingAccount/BillingCreate.tsx
#: src/modules/billing/choose_method/ChooseMethod.tsx
msgid "Choose method"
msgstr "Pilih metode"

#: src/modules/network/NetworkCreate.tsx
msgid "Choose the VPC network the target servers are in."
msgstr "Pilih jaringan VPC tempat server target berada."

#: src/modules/compute/VmCreate.tsx
msgid "Choose UEFI if the VM you are importing requires it."
msgstr "Pilih UEFI jika VM yang Anda impor memerlukannya."

#. Part of address
#: src/modules/billing/billingAccount/fieldsInfo.tsx
msgid "City"
msgstr "Kota"

#: src/modules/metal/status/StatusLabels.tsx
msgid "Cleaning"
msgstr "Pembersihan"

#. Billing account restriction level | POS: Adjective
#: src/modules/billing/statusHistory/statusHistoryLabels.tsx
msgid "Clear"
msgstr ""

#: src/modules/notifications/NotificationMenu.tsx
msgid "Clear all"
msgstr "Hapus semua"

#. Button: Remove the over-ride of the billing account for this bucket
#: src/modules/storage/bucket/BucketView.tsx
msgid "Clear override"
msgstr "Hapus penggantian"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Clear uploads"
msgstr "Hapus daftar unggahan"

#: src/modules/billing/paypal/PaypalVaultAddForm.tsx
msgid "Click the button to connect to PayPal."
msgstr "Klik tombol untuk menghubungkan ke PayPal."

#: src/modules/compute/VmCloneModal.tsx
#: src/modules/compute/VmCloneModal.tsx
#: src/modules/disks/disk/DiskCloneModal.tsx
#: src/modules/disks/disk/DiskCloneModal.tsx
msgid "Clone"
msgstr "Kloning"

#: src/modules/compute/VmCloneModal.tsx
#: src/modules/disks/disk/DiskCloneModal.tsx
msgid "Clone resource"
msgstr "Kloning resource"

#. Button action
#: src/components/modal/WModal.tsx
#: src/components/sidebar/ErrorItem.tsx
#: src/modules/access/delegation/AddImpersonationForm.tsx
#: src/modules/compute/AddFirewallForm.tsx
#: src/modules/network/firewall/AddResourceForm.tsx
#: src/modules/network/loadbalancer/AddForwardingRuleForm.tsx
#: src/modules/network/loadbalancer/AddTargetServerForm.tsx
#: src/modules/services/AddIpForm.tsx
msgid "Close"
msgstr "Tutup"

#. Label for an authentication error code
#: src/modules/login/auth0/Auth0Login.tsx
msgid "Code:"
msgstr "Kode:"

#. Server has been pre-paid
#: src/modules/metal/commitment/CommitmentPriceBlock.tsx
msgid "Committed"
msgstr "Prabayar"

#: src/modules/billing/billingAccount/fieldsInfo.tsx
msgid "Company name"
msgstr "Nama perusahaan"

#: src/styles/dataxion/theme.tsx
msgid "Company RNE number"
msgstr "Nomor RNE perusahaan"

#: src/modules/access/token/TokenView.tsx
msgid "Comprehensive API manual with code samples is available here:"
msgstr "Manual API lengkap dengan contoh kode tersedia di sini:"

#: src/modules/api/resourceTypes.tsx
#: src/modules/compute/VmList.tsx
#: src/modules/main/sidebar/Sidebar.sections.tsx
msgid "Compute"
msgstr "Komputasi"

#. Alternative: Configure a custom subnet range
#: src/modules/network/NetworkCreate.tsx
msgid "Configure my own"
msgstr "Konfigurasikan sendiri"

#: src/modules/login/Login.tsx
msgid "Confirm email"
msgstr "Konfirmasi email"

#: src/modules/compute/PasswordFields.tsx
msgid "Confirm password"
msgstr "Konfirmasi kata sandi"

#: src/modules/login/Login.tsx
msgid "Confirm your email address by clicking the verification link we just sent to your inbox."
msgstr "Konfirmasikan alamat email Anda dengan mengeklik tautan verifikasi yang baru saja kami kirim ke kotak masuk Anda."

#: src/components/modal/DeleteModal.tsx
#: src/modules/main/LogoutConfirmDialog.tsx
msgid "Confirmation"
msgstr "Konfirmasi"

#: src/modules/compute/WVnc.tsx
msgid "Connect"
msgstr "Hubungkan"

#: src/modules/billing/paypal/PaypalVaultAddForm.tsx
msgid "Connect to PayPal first"
msgstr "Hubungkan ke PayPal terlebih dahulu"

#: src/modules/compute/WVnc.tsx
msgid "Connecting"
msgstr "Menghubungkan"

#: src/modules/billing/progressLabels.tsx
msgid "Connecting payment method"
msgstr "Menghubungkan metode pembayaran"

#. Title for section that contains credentials to connect to a database
#: src/modules/services/ConnectionDetails.tsx
#: src/modules/services/ServiceView.tsx
msgid "Connection details"
msgstr "Detail koneksi"

#: src/modules/billing/billingAccount/fieldsInfo.tsx
msgid "Contact person's name"
msgstr "Nama narahubung"

#: src/modules/billing/billingAccount/fieldsInfo.tsx
msgid "Contact person's phone"
msgstr "Telepon narahubung"

#: src/modules/billing/BillingAccountInfo.tsx
#: src/modules/support/ContactSupportButton.tsx
msgid "Contact support"
msgstr "Hubungi dukungan"

#: src/modules/billing/account_validation/digio/StartDigioValidationButton.tsx
#: src/modules/login/ConsentForm.tsx
#: src/modules/login/Login.tsx
msgid "Continue"
msgstr "Lanjutkan"

#: src/components/ClipBoardTooltip.tsx
msgid "Copied!"
msgstr "Disalin!"

#. Full form: Copy to clipboard
#: src/modules/services/ConnectionDetails.tsx
#: src/modules/storage/account/StorageAccountView.tsx
msgid "Copy"
msgstr "Salin"

#: src/modules/services/Access.tsx
msgid "Copy config to clipboard"
msgstr "Salin konfigurasi ke clipboard"

#: src/modules/storage/s3/S3FileBrowser.tsx
#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Copy public URL"
msgstr "Salin URL publik"

#: src/components/ClipBoardTooltip.tsx
msgid "Copy to clipboard"
msgstr "Salin ke clipboard"

#. All the main resources and services offered by the cloud platform
#: src/modules/dashboard/StartSomethingNew.tsx
msgid "Core services"
msgstr "Layanan inti"

#. Part of address
#: src/modules/billing/billingAccount/fieldsInfo.tsx
msgid "Country"
msgstr "Negara"

#. Part of address
#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/billingAccount/fieldsInfo.tsx
msgid "County"
msgstr "Kabupaten"

#: src/modules/compute/MetricsGrid.tsx
#: src/modules/compute/VmSizeSelect.tsx
#: src/modules/compute/VmSizeSelect.tsx
msgid "CPU"
msgstr "CPU"

#. Button: Create a new resource
#: src/components/forms/CreateFormAction.tsx
#: src/modules/billing/billingAccount/BillingCreate.tsx
#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Create"
msgstr "Buat"

#. Button: Create new billing account
#: src/modules/dashboard/BillingAccounts.tsx
msgctxt "Should be short (1-3 words)"
msgid "Create"
msgstr "Buat"

#: src/modules/billing/BillingList.tsx
msgid "Create a billing account first, then you can start creating resources."
msgstr "Buat akun penagihan terlebih dahulu, lalu Anda dapat mulai membuat sumber daya."

#: src/modules/api/resourceTypes.tsx
msgid "Create a dedicated bare metal server and run your application with maximum performance."
msgstr "Buat server bare metal khusus dan jalankan aplikasi Anda dengan performa maksimal."

#: src/modules/error/ErrorFallback.tsx
msgid "Create a new {resourceTypeName}"
msgstr "Buat {resourceTypeName} baru"

#: src/modules/access/AccessList.tsx
msgid "Create a new access to enable other users or systems to perform actions with this {siteName} account."
msgstr "Buat akses baru untuk memungkinkan pengguna atau sistem lain melakukan tindakan dengan akun {siteName} ini."

#: src/modules/disks/DiskList.tsx
msgid "Create a new disk and start storing your data."
msgstr "Buat disk baru dan mulai simpan data Anda."

#: src/modules/compute/VmList.tsx
#: src/modules/metal/MetalList.tsx
msgid "Create a new resource and get your services running in minutes."
msgstr "Buat resource baru dan jalankan layanan Anda dalam hitungan menit."

#: src/modules/network/NetworkList.tsx
msgid "Create a new resource and start managing your network."
msgstr "Buat sumber daya baru dan mulai kelola jaringan Anda."

#: src/modules/services/ServicesList.tsx
msgid "Create a new service and get it running in minutes."
msgstr "Buat layanan baru dan jalankan dalam hitungan menit."

#: src/modules/api/resourceTypes.tsx
msgid "Create a new storage account, create some buckets and start storing your data in a scalable way - Pay-as-you-grow."
msgstr "Buat akun penyimpanan baru, buat beberapa bucket, dan mulai simpan data Anda dengan cara yang skalabel - bayar sesuai pertumbuhan penggunaan."

#: src/modules/storage/StorageList.tsx
msgid "Create a new storage account, create some buckets and start storing your data."
msgstr "Buat akun penyimpanan baru, buat beberapa bucket, dan mulai simpan data Anda."

#: src/modules/api/resourceTypes.tsx
msgid "Create a new Virtual Machine or choose something from the App Catalog to get your services running in minutes."
msgstr "Buat Mesin Virtual baru atau pilih sesuatu dari Katalog Aplikasi agar layanan Anda dapat berjalan dalam hitungan menit."

#: src/modules/api/resourceTypes.tsx
msgid "Create a personal Virtual Private Cloud (VPC) and start managing your networks."
msgstr "Buat Virtual Private Cloud (VPC) pribadi dan mulai kelola jaringan Anda."

#: src/modules/network/CreateAndAssignIpField.tsx
msgid "Create a public IPv4 address for the resource"
msgstr "Buat alamat IPv4 publik untuk sumber daya"

#: src/modules/disks/DiskCreate.tsx
msgid "Create additional storage for your workloads. Configure the disk and attach it to a virtual machine now or later."
msgstr "Buat penyimpanan tambahan untuk beban kerja Anda. Konfigurasikan disk dan pasangkan ke virtual machine sekarang atau nanti."

#: src/modules/login/Login.tsx
msgid "Create an account"
msgstr "Buat akun"

#: src/modules/api/resourceTypes.tsx
msgid "Create an API Token to use our API."
msgstr "Buat Token API untuk menggunakan API kami."

#. placeholder {0}: getResourceTypeName(type)
#: src/components/loading/Loading.tsx
msgid "Create another {0}"
msgstr "Buat {0} lain"

#: src/components/forms/CreateBillingAccount.tsx
msgid "Create billing account"
msgstr "Buat akun penagihan"

#: src/components/forms/CreateBillingAccount.tsx
#: src/modules/access/AccessCreate.tsx
#: src/modules/access/AccessList.tsx
#: src/modules/billing/billingAccount/BillingCreate.tsx
#: src/modules/billing/BillingList.tsx
#: src/modules/compute/VmCreate.tsx
#: src/modules/compute/VmList.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/dashboard/AppCatalog.tsx
#: src/modules/dashboard/CoreServices.tsx
#: src/modules/dashboard/ManagedServices.tsx
#: src/modules/disks/DiskCreate.tsx
#: src/modules/disks/DiskList.tsx
#: src/modules/metal/MetalCreate.tsx
#: src/modules/metal/MetalList.tsx
#: src/modules/network/NetworkCreate.tsx
#: src/modules/network/NetworkList.tsx
#: src/modules/services/ServiceCreate.tsx
#: src/modules/services/ServicesList.tsx
#: src/modules/storage/account/CreateBucketModal.tsx
#: src/modules/storage/account/CreateBucketModal.tsx
#: src/modules/storage/account/CreateKeyModal.tsx
#: src/modules/storage/account/CreateKeyModal.tsx
#: src/modules/storage/StorageCreate.tsx
#: src/modules/storage/StorageList.tsx
msgid "Create new"
msgstr "Buat baru"

#. Created at timestamp
#: src/modules/access/AccessList.tsx
#: src/modules/access/AccessList.tsx
#: src/modules/access/delegation/DelegationView.tsx
#: src/modules/access/delegation/DelegationView.tsx
#: src/modules/access/token/TokenView.tsx
#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/disks/disk/DiskView.tsx
#: src/modules/disks/disk/DiskView.tsx
#: src/modules/metal/MetalLeaseDetailView.tsx
#: src/modules/network/firewall/FirewallView.tsx
#: src/modules/network/ipAddress/IpAddressView.tsx
#: src/modules/network/loadbalancer/LoadBalancerView.tsx
#: src/modules/network/vpc/VpcView.tsx
#: src/modules/services/Backups.tsx
#: src/modules/services/ServiceView.tsx
#: src/modules/storage/account/StorageAccountView.tsx
#: src/modules/storage/account/StorageAccountView.tsx
#: src/modules/storage/bucket/BucketView.tsx
#: src/modules/user/ProfileView.tsx
#: src/modules/user/ProfileView.tsx
msgid "Created"
msgstr "Dibuat"

#: src/modules/storage/account/StorageAccountView.tsx
#: src/modules/user/ProfileView.tsx
msgid "Created at"
msgstr "Dibuat pada"

#: src/modules/access/AccessList.tsx
#: src/modules/billing/BillingList.tsx
#: src/modules/compute/VmList.tsx
#: src/modules/disks/DiskList.tsx
#: src/modules/metal/MetalList.tsx
#: src/modules/network/NetworkList.tsx
#: src/modules/services/ServicesList.tsx
msgid "Created date"
msgstr "Tanggal dibuat"

#: src/modules/compute/ModalHeaderBlock.tsx
msgid "Created from"
msgstr "Dibuat dari"

#. Virtual machine status
#: src/components/loading/Loading.tsx
#: src/modules/compute/statusLabels.tsx
msgid "Creating"
msgstr "Membuat"

#: src/modules/access/AccessCreate.tsx
msgid "Creating an access by API Token gives you a key to use with our API."
msgstr "Membuat akses dengan Token API memberi Anda kunci untuk digunakan dengan API kami."

#: src/modules/billing/invoice/InvoiceView.tsx
msgid "Credit"
msgstr "Kredit"

#. What caused the billing account status change
#: src/modules/billing/statusHistory/statusHistoryLabels.tsx
msgid "Credit adjustment"
msgstr ""

#: src/modules/billing/evc_hormuud/EvcHormuudPaymentForm.tsx
msgid "Credit is added to this billing account automatically once the payment is received. Make sure the billing account ID is entered correctly."
msgstr ""

#: src/modules/billing/invoice/invoiceLogic.tsx
msgid "Credit Note {id}"
msgstr "Nota kredit {id}"

#. Metal coverage status
#: src/modules/metal/statusLabels.tsx
msgid "Current"
msgstr "Saat ini"

#: src/modules/metal/commitment/AddCommitmentModal.tsx
msgid "Current billing cycle"
msgstr "Siklus penagihan saat ini"

#. Explanation: Restoring a snapshot or backup will delete the current state of the virtual machine.
#: src/modules/compute/VmRestoreFromReplicaModal.tsx
msgid "Current changes will be discarded."
msgstr "Perubahan saat ini akan dibuang."

#: src/modules/billing/invoice/invoiceLogic.tsx
msgid "Current usage"
msgstr "Penggunaan saat ini"

#: src/modules/compute/VmSizeSelect.tsx
msgid "Currently not available"
msgstr "Saat ini tidak tersedia"

#. Custom operating system
#: src/modules/compute/os/OsInfo.tsx
#: src/modules/network/firewall/ruleSpec.tsx
msgid "Custom"
msgstr "Kustom"

#: src/modules/compute/BootFromIsoModal.tsx
msgid "Custom ISO image"
msgstr "Image ISO kustom"

#: src/modules/support/WChatProvider.tsx
msgid "Customer support"
msgstr "Dukungan pelanggan"

#: src/modules/billing/payment_forms/labels.tsx
msgid "CVC"
msgstr "CVC"

#: src/modules/main/ColorSchemeMenu.tsx
msgid "Dark"
msgstr "Gelap"

#: src/modules/dashboard/Dashboard.tsx
#: src/modules/main/sidebar/Sidebar.sections.tsx
msgid "Dashboard"
msgstr "Dasbor"

#: src/modules/location/LocationDetail.tsx
msgid "Data center where resource is located"
msgstr "Pusat data tempat resource berada"

#: src/modules/location/LocationField.tsx
msgid "Data center where the resource will be created."
msgstr "Pusat data tempat resource akan dibuat."

#: src/components/forms/WSelect.tsx
msgid "Data missing"
msgstr "Data tidak tersedia"

#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/user/ProfileView.tsx
msgid "Date"
msgstr "Tanggal"

#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "Declined / Suspended"
msgstr "Ditolak / Ditangguhkan"

#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/BillingList.tsx
#: src/modules/dashboard/BillingAccounts.tsx
#: src/modules/network/NetworkList.tsx
#: src/modules/network/vpc/VpcView.tsx
msgid "Default"
msgstr "Default"

#: src/modules/billing/statusHistory/StatusHistory.tsx
msgid "Default level for post-payment billing accounts"
msgstr ""

#: src/modules/access/AccessCreate.tsx
msgid "Delegate access to"
msgstr "Delegasikan akses kepada"

#: src/modules/api/resourceTypes.tsx
msgid "Delegate access to your user or billing account so trusted users can manage your resources."
msgstr "Delegasikan akses ke pengguna atau akun penagihan Anda agar pengguna tepercaya dapat mengelola sumber daya Anda."

#: src/modules/user/ProfileView.tsx
msgid "Delegate new access"
msgstr "Delegasikan akses baru"

#: src/modules/access/AccessCreate.tsx
msgid "Delegating access to a chosen trusted user enables the user to act as you and perform all operations on behalf of your user or billing account."
msgstr "Mendelegasikan akses kepada pengguna tepercaya yang dipilih memungkinkan pengguna tersebut bertindak sebagai Anda dan melakukan semua operasi atas nama akun pengguna atau akun penagihan Anda."

#: src/components/button/DeleteButton.tsx
#: src/components/modal/DeleteModal.tsx
#: src/modules/storage/s3/S3FileBrowser.tsx
#: src/modules/storage/s3/S3FileBrowser.tsx
#: src/modules/storage/s3/S3FileBrowser.tsx
#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Delete"
msgstr "Hapus"

#: src/modules/network/DeleteWithFloatingIp.tsx
msgid "Delete floating IP"
msgstr "Hapus Floating IP"

#. Virtual machine status
#: src/modules/compute/statusLabels.tsx
#: src/modules/metal/status/StatusLabels.tsx
msgid "Deleted"
msgstr "Dihapus"

#: src/modules/metal/MetalDeleteModal.tsx
msgid "Deleting \"{display_name}\" will permanently remove it, and it will not be accessible after that."
msgstr "Menghapus \"{display_name}\" akan menghapusnya secara permanen, dan setelah itu tidak akan dapat diakses."

#: src/modules/metal/MetalDeleteModal.tsx
msgid "Deleting \"{display_name}\" would destroy a resource that has already been paid for. Please contact support for assistance."
msgstr "Menghapus \"{display_name}\" akan menghapus sumber daya yang telah dibayar. Silakan hubungi dukungan untuk bantuan."

#: src/modules/access/delegation/DelegationView.tsx
msgid "Deleting \"{name}\" will permanently remove access from all the users in this group to act as you."
msgstr "Menghapus \"{name}\" akan secara permanen menghapus akses semua pengguna dalam grup ini untuk bertindak sebagai Anda."

#. Items: means files or folders
#. placeholder {0}: files.length
#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Deleting {count} {0, plural, one {item} other {items}}."
msgstr "Menghapus {count} {0, plural, one {item} other {item}}."

#: src/modules/compute/VmDeleteReplicaModal.tsx
msgid "Deleting a backup will permanently remove it."
msgstr "Menghapus cadangan akan menghapusnya secara permanen."

#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "Deleting a billing account \"{title}\" will remove it permanently. Billing account can be deleted only if there are no unpaid resources attached to it and if it has no unspent credit."
msgstr "Menghapus akun penagihan \"{title}\" akan menghapusnya secara permanen. Akun penagihan hanya dapat dihapus jika tidak ada sumber daya yang belum dibayar yang terhubung dengannya dan jika tidak memiliki kredit tersisa yang belum digunakan."

#. placeholder {0}: method.name
#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "Deleting a payment method \"{0}\" will remove it from the billing account."
msgstr "Menghapus metode pembayaran \"{0}\" akan menghapusnya dari akun penagihan."

#: src/modules/services/ServiceDeleteModal.tsx
msgid "Deleting a service will also delete your backups and the service cannot be restored after that."
msgstr "Menghapus layanan juga akan menghapus backup Anda dan layanan tersebut tidak dapat dipulihkan setelah itu."

#: src/modules/compute/VmDeleteReplicaModal.tsx
msgid "Deleting a snapshot will permanently remove it."
msgstr "Menghapus snapshot akan menghapusnya secara permanen."

#: src/modules/storage/account/StorageAccountView.tsx
msgid "Deleting the access key \"{accessKey}\" will permanently remove it, and it cannot be used for accessing the storage API after that."
msgstr "Menghapus kunci akses \"{accessKey}\" akan menghapusnya secara permanen, dan kunci tersebut tidak dapat lagi digunakan untuk mengakses API penyimpanan setelah itu."

#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "Deleting the credit card \"{placeholder}\" will permanently remove it from the billing account."
msgstr "Menghapus kartu kredit \"{placeholder}\" akan menghapusnya secara permanen dari akun penagihan."

#: src/modules/compute/DiskDeleteModal.tsx
msgid "Deleting the disk will permanently remove it, and it will not be accessible after that."
msgstr "Menghapus disk akan menghapusnya secara permanen, dan setelah itu disk tidak akan dapat diakses."

#. placeholder {0}: name || address
#: src/modules/network/ipAddress/IpAddressView.tsx
msgid "Deleting the floating IP address \"{0}\" will remove it from your account and release it to the public pool."
msgstr "Menghapus alamat Floating IP \"{0}\" akan menghapusnya dari akun Anda dan melepaskannya ke pool publik."

#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "Deleting the invoice method will permanently remove it from the billing account."
msgstr "Menghapus metode pembayaran faktur akan menghapusnya secara permanen dari akun penagihan."

#: src/modules/services/ServiceDeleteModal.tsx
msgid "Deleting the service \"{display_name}\" will permanently remove it, and it will not be accessible after that."
msgstr "Menghapus layanan \"{display_name}\" akan menghapusnya secara permanen, dan layanan tersebut tidak akan dapat diakses setelah itu."

#: src/modules/storage/account/StorageAccountView.tsx
msgid "Deleting the storage account \"{title}\" will permanently remove it and delete all associated keys. Accounts with active buckets cannot be deleted."
msgstr "Menghapus akun penyimpanan \"{title}\" akan menghapusnya secara permanen beserta semua kunci terkait. Akun dengan bucket aktif tidak dapat dihapus."

#: src/modules/storage/account/StorageAccountView.tsx
#: src/modules/storage/bucket/BucketView.tsx
msgid "Deleting the storage bucket \"{name}\" will permanently remove it, and any files in it will not be accessible after that."
msgstr "Menghapus bucket penyimpanan \"{name}\" akan menghapusnya secara permanen, dan semua file di dalamnya tidak akan dapat diakses setelah itu."

#: src/modules/access/token/TokenView.tsx
msgid "Deleting the token \"{description}\" will permanently remove it, and it cannot be used for authentication after that."
msgstr "Menghapus token \"{description}\" akan menghapusnya secara permanen, dan setelah itu token tersebut tidak dapat digunakan untuk autentikasi."

#: src/modules/compute/VmDeleteModal.tsx
msgid "Deleting the virtual machine \"{name}\" will permanently remove it, and it will not be accessible after that."
msgstr "Menghapus mesin virtual \"{name}\" akan menghapusnya secara permanen, dan setelah itu mesin virtual tidak akan dapat diakses."

#: src/modules/compute/VmDeleteModal.tsx
msgid "Deleting the virtual machine will also delete your backups and snapshots, and the machine cannot be restored after that. If you wish to keep the backups and snapshots consider stopping the machine instead."
msgstr "Menghapus mesin virtual juga akan menghapus cadangan dan snapshot Anda, dan mesin tidak dapat dipulihkan setelah itu. Jika Anda ingin menyimpan cadangan dan snapshot, pertimbangkan untuk menghentikan mesin sebagai gantinya."

#: src/modules/network/vpc/VpcView.tsx
msgid "Deleting the VPC network \"{name}\" will remove it from your account."
msgstr "Menghapus jaringan VPC \"{name}\" akan menghapusnya dari akun Anda."

#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/network/loadbalancer/LoadBalancerView.tsx
#: src/modules/services/ServiceView.tsx
msgid "Description"
msgstr "Deskripsi"

#: src/modules/compute/VmView.tsx
#: src/modules/network/firewall/EditRuleModal.tsx
#: src/modules/network/firewall/FirewallView.tsx
#: src/modules/network/firewall/RulesList.tsx
msgid "Destinations"
msgstr "Tujuan"

#: src/modules/disks/AttachedToSelect.tsx
#: src/modules/disks/DiskList.tsx
#: src/modules/disks/UnattachedItem.tsx
msgid "Detached"
msgstr "Tidak terpasang"

#: src/modules/compute/VmView.tsx
msgid "Disable"
msgstr "Nonaktifkan"

#: src/modules/compute/VmView.tsx
msgid "Disable backups"
msgstr "Nonaktifkan backup"

#: src/modules/user/ProfileView.tsx
msgid "Disable MFA"
msgstr "Nonaktifkan MFA"

#: src/components/EnabledDisabled.tsx
msgid "Disabled"
msgstr "Dinonaktifkan"

#: src/modules/compute/WVnc.tsx
msgid "Disconnect"
msgstr "Putuskan"

#. State of connection: Not connected
#: src/modules/compute/WVnc.tsx
msgid "Disconnected"
msgstr "Terputus"

#. Column title for invoice records' discount
#: src/components/PriceWithDiscount.tsx
#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/invoice/InvoiceView.tsx
#: src/modules/billing/invoice/InvoiceView.tsx
#: src/modules/billing/invoice/InvoiceView.tsx
msgid "Discount"
msgstr "Diskon"

#: src/modules/api/resourceTypes.tsx
#: src/modules/services/kubernetes/Infrastructure.tsx
#: src/modules/services/kubernetes/NodePoolsList.tsx
msgid "Disk"
msgstr "Disk"

#: src/modules/compute/MetricsGrid.tsx
msgid "Disk I/O"
msgstr "I/O Disk"

#: src/modules/compute/DiskAddOrResizeModal.tsx
#: src/modules/compute/VmResizeModal.tsx
msgid "Disk size can only be increased. This action is not reversible. Minimum disk size:"
msgstr "Ukuran disk hanya dapat diperbesar. Tindakan ini tidak dapat dibatalkan. Ukuran minimum disk:"

#: src/modules/api/resourceTypes.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/disks/DiskList.tsx
#: src/modules/main/sidebar/Sidebar.sections.tsx
msgid "Disks"
msgstr "Disk"

#: src/modules/billing/CurrencyPaymentFees.tsx
#: src/modules/currency/CurrencyModal.tsx
#: src/modules/currency/CurrencyModal.tsx
msgid "Display currency"
msgstr "Mata uang tampilan"

#: src/modules/storage/StorageCreate.tsx
msgid "Display name"
msgstr "Nama tampilan"

#: src/modules/billing/billingAccount/BillingCreate.tsx
msgid "Document"
msgstr "Dokumen"

#: src/modules/billing/billingAccount/fieldsInfo.tsx
msgid "Document file"
msgstr "File dokumen"

#: src/modules/billing/invoice/InvoiceView.tsx
#: src/modules/billing/InvoicePaymentInfo.tsx
msgid "Document No."
msgstr "No. dokumen"

#. Button action to download a file. | POS: Verb
#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Download"
msgstr "Unduh"

#: src/modules/services/Access.tsx
msgid "Download config file"
msgstr "Unduh file konfigurasi"

#: src/modules/billing/invoice/DownloadPdf.tsx
msgid "Download PDF"
msgstr "Unduh PDF"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Drop files here"
msgstr "Lepas file di sini"

#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/invoice/InvoiceView.tsx
msgid "Due date"
msgstr "Jatuh tempo"

#: src/modules/login/auth0/Auth0Login.tsx
msgid "E-mail"
msgstr "Email"

#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/compute/UpdateSshKeyModal.tsx
#: src/modules/network/firewall/EditRuleModal.tsx
#: src/modules/network/firewall/FirewallView.tsx
#: src/modules/services/kubernetes/Infrastructure.tsx
#: src/modules/services/kubernetes/MaintenanceEditModal.tsx
#: src/modules/services/kubernetes/MaintenanceEditModal.tsx
#: src/modules/services/kubernetes/NodePoolsList.tsx
#: src/modules/services/kubernetes/NodeResizeModal.tsx
#: src/modules/storage/account/UpdateKeyModal.tsx
#: src/modules/storage/account/UpdateKeyModal.tsx
msgid "Edit"
msgstr "Edit"

#: src/modules/billing/billingAccount/BillingCreate.tsx
msgid "Edit \"{title}\""
msgstr "Edit \"{title}\""

#: src/modules/services/kubernetes/MaintenanceEditModal.tsx
msgid "Edit maintenance"
msgstr "Edit pemeliharaan"

#: src/modules/storage/account/UpdateKeyModal.tsx
msgid "Edit name"
msgstr "Edit nama"

#: src/modules/services/kubernetes/NodeResizeModal.tsx
msgid "Edit node"
msgstr "Edit node"

#: src/modules/network/firewall/EditRuleModal.tsx
msgid "Edit rule"
msgstr "Edit aturan"

#. Field label
#: src/components/EditableList.tsx
#: src/modules/login/Login.tsx
#: src/modules/user/ProfileView.tsx
msgid "Email"
msgstr "Email"

#: src/modules/login/auth0/Auth0Exception.ts
msgid "Email domain is prohibited"
msgstr "Domain email tidak diizinkan"

#: src/modules/login/Login.tsx
msgid "Email verification failed"
msgstr "Verifikasi email gagal"

#: src/modules/login/Login.tsx
msgid "Email verified"
msgstr "Email terverifikasi"

#: src/modules/billing/billingAccount/BillingCreate.tsx
msgid "Email where invoices and reports are sent."
msgstr "Email tempat faktur dan laporan dikirim."

#: src/modules/compute/VmCreate.tsx
msgid "Empty disk (for ISO booting)"
msgstr "Disk kosong (untuk boot dari ISO)"

#: src/modules/billing/AutomatedTopUpModal.tsx
#: src/modules/billing/LowBalanceNotificationsModal.tsx
msgid "Enable"
msgstr "Aktifkan"

#: src/modules/user/ProfileView.tsx
msgid "Enable MFA"
msgstr "Aktifkan MFA"

#: src/modules/access/AccessCreate.tsx
msgid "Enable other users or systems to perform actions with resources connected to this account."
msgstr "Izinkan pengguna atau sistem lain melakukan tindakan pada sumber daya yang terhubung ke akun ini."

#: src/components/EnabledDisabled.tsx
msgid "Enabled"
msgstr "Diaktifkan"

#: src/modules/metal/MetalLeaseDetailView.tsx
msgid "End date"
msgstr "Tanggal berakhir"

#: src/modules/network/firewall/firewallLabels.tsx
msgid "End port"
msgstr "Port akhir"

#: src/modules/network/firewall/validatePorts.ts
msgid "End port must be greater than start port"
msgstr "Port akhir harus lebih besar dari port awal"

#. Metal commitment status
#: src/modules/metal/statusLabels.tsx
msgid "Ended"
msgstr "Berakhir"

#: src/modules/compute/AddSubInterfaceModal.tsx
msgid "Enter a value between 1 and 4094"
msgstr "Masukkan nilai antara 1 dan 4094"

#. Card security code validation error
#: src/modules/billing/omise/OmiseCardAddForm.tsx
msgid "Enter digits only"
msgstr "Masukkan angka saja"

#. placeholder {0}: currency.title
#: src/modules/billing/payment/PaymentModal.tsx
msgid "Enter the top up amount in {0} (minimum {minimumAmount}):"
msgstr "Masukkan jumlah isi saldo dalam {0} (minimum {minimumAmount}):"

#: src/modules/billing/payment/PaymentModal.tsx
#: src/modules/error/Isolated.tsx
#: src/modules/login/Login.tsx
#: src/modules/notifications/toast.tsx
msgid "Error"
msgstr "Kesalahan"

#: src/modules/billing/choose_method/AddPaymentMethodModal.tsx
#: src/modules/billing/payment/PaymentModal.tsx
msgid "Error adding payment method"
msgstr "Terjadi kesalahan saat menambahkan metode pembayaran"

#: src/modules/login/auth0/Auth0Exception.ts
msgid "Error code: {code}"
msgstr "Kode kesalahan: {code}"

#: src/components/button/WButton.tsx
msgid "Error performing action"
msgstr "Terjadi kesalahan saat melakukan tindakan"

#: src/modules/notifications/toast.tsx
msgid "Error saving changes"
msgstr "Terjadi kesalahan saat menyimpan perubahan"

#: src/modules/compute/VmView.tsx
msgid "Est. cost per backup"
msgstr "Perkiraan biaya per cadangan"

#: src/components/table/DetailsTableMonthlyCost.tsx
#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/disks/disk/DiskView.tsx
#: src/modules/services/ServiceView.tsx
#: src/modules/storage/account/StorageAccountView.tsx
msgid "Est. monthly cost"
msgstr "Perkiraan biaya bulanan"

#. Short of: Estimated
#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "Est. total"
msgstr "Perk. total"

#: src/components/forms/MonthlyCostField.tsx
msgid "Estimated cost"
msgstr "Perkiraan biaya"

#: src/modules/pricing/ReplicaPrice.tsx
msgid "Estimated price per backup is {priceWithDiscount} per month."
msgstr "Perkiraan harga per backup adalah {priceWithDiscount} per bulan."

#: src/modules/pricing/ReplicaPrice.tsx
msgid "Estimated price per snapshot is {priceWithDiscount} per month."
msgstr "Perkiraan harga per snapshot adalah {priceWithDiscount} per bulan."

#. Table column: what happened to the billing account
#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "Event"
msgstr ""

#: src/modules/billing/referral/ReferralProgram.tsx
msgid "Every new user receives a {c_totalReceiverCredit} worth of free credits when signing up through the referral link or code and adding a verified payment method."
msgstr "Setiap pengguna baru akan menerima kredit gratis senilai {c_totalReceiverCredit} saat mendaftar melalui tautan atau kode referral dan menambahkan metode pembayaran yang terverifikasi."

#: src/modules/billing/referral/ReferralProgram.tsx
msgid "Every new user who signs up through the referral program and tops up at least {c_minimumTopUp} will receive a bonus worth of {c_totalReceiverCredit} credits."
msgstr "Setiap pengguna baru yang mendaftar melalui program referral dan mengisi saldo minimal {c_minimumTopUp} akan menerima bonus kredit senilai {c_totalReceiverCredit}."

#: src/modules/compute/SubInterfaceModal.tsx
msgid "Example"
msgstr "Contoh"

#: src/modules/currency/CurrencyModal.tsx
#: src/modules/currency/DisplayCurrencyRate.tsx
msgid "Exchange rate"
msgstr "Nilai tukar"

#. Short of: Excluding (VAT/GST etc.)
#: src/modules/billing/invoice/InvoiceView.tsx
msgid "Excl. {vatSymbol}"
msgstr "Tidak termasuk {vatSymbol}"

#. The number of fail-over nodes:
#: src/modules/services/ServiceCreate.tsx
msgid "Fail-over nodes"
msgstr "Node fail-over"

#: src/modules/api/ApiError.ts
msgid "Failed to connect to server"
msgstr "Gagal terhubung ke server"

#: src/modules/billing/account_validation/digio/utils.ts
msgid "Failed to load Digio library"
msgstr "Gagal memuat pustaka Digio"

#: src/modules/billing/paypal/utils.ts
msgid "Failed to load PayPal library"
msgstr "Gagal memuat pustaka PayPal"

#: src/modules/billing/popup/popup.ts
msgid "Failed to open popup, possible popup blocker usage"
msgstr "Gagal membuka popup, kemungkinan pemblokir popup sedang digunakan"

#: src/modules/storage/s3/S3FileBrowser.tsx
#: src/modules/storage/s3/S3FileBrowser.tsx
#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "File"
msgstr "File"

#: src/modules/storage/bucket/BucketView.tsx
msgid "Files"
msgstr "File"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Files will be uploaded to"
msgstr "File akan diunggah ke"

#: src/modules/api/resourceTypes.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/compute/VmView.tsx
msgid "Firewall"
msgstr "Firewall"

#: src/modules/network/NetworkCreate.tsx
msgid "Firewall is available at no additional cost."
msgstr "Firewall tersedia tanpa biaya tambahan."

#: src/modules/compute/VmView.tsx
msgid "Firewall name"
msgstr "Nama firewall"

#: src/modules/dashboard/WelcomeBlock.tsx
msgid "Firewall now available"
msgstr "Firewall kini tersedia"

#: src/modules/user/ProfileView.tsx
msgid "First name"
msgstr "Nama depan"

#: src/modules/services/ConnectionDetails.tsx
msgid "Flags"
msgstr "Flag"

#: src/modules/api/resourceTypes.tsx
msgid "Floating IP"
msgstr "Floating IP"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Folder"
msgstr "Folder"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Folder name"
msgstr "Nama folder"

#: src/modules/billing/referral/ReferralProgram.tsx
msgid "For every new user who signs up through the referral program and tops up at least {c_minimumTopUp}, you will receive {c_promoterCredit} worth of free credits."
msgstr "Untuk setiap pengguna baru yang mendaftar melalui program referral dan mengisi saldo minimal {c_minimumTopUp}, Anda akan menerima kredit gratis senilai {c_promoterCredit}."

#: src/modules/billing/referral/ReferralProgram.tsx
msgid "For every new user who signs up using your referral code and adds a verified payment method, you will receive {c_promoterCredit} worth of free credits."
msgstr "Untuk setiap pengguna baru yang mendaftar menggunakan kode referral Anda dan menambahkan metode pembayaran yang terverifikasi, Anda akan menerima kredit gratis senilai {c_promoterCredit}."

#: src/modules/billing/billingAccount/BillingCreate.tsx
msgid "For pay-as-you-go billing account you can select the payment method after the account is created and validated."
msgstr "Untuk akun penagihan bayar sesuai pemakaian, Anda dapat memilih metode pembayaran setelah akun dibuat dan divalidasi."

#: src/modules/compute/labels.tsx
msgid "For the snapshots you will only pay for the storage used by the snapshot."
msgstr "Untuk snapshot, Anda hanya akan membayar penyimpanan yang digunakan oleh snapshot."

#. Unsafely shut down the virtual machine
#: src/modules/compute/VmToolbar.tsx
#: src/modules/compute/VmToolbar.tsx
#: src/modules/compute/VmToolbar.tsx
msgid "Force stop"
msgstr "Hentikan paksa"

#: src/modules/login/Login.tsx
#: src/modules/login/Login.tsx
msgid "Forgot password"
msgstr "Lupa kata sandi"

#: src/modules/network/loadbalancer/LoadBalancerView.tsx
#: src/modules/network/loadbalancer/LoadBalancerView.tsx
#: src/modules/network/NetworkCreate.tsx
msgid "Forwarding rules"
msgstr "Aturan penerusan"

#. At no cost. | POS: Noun
#: src/components/forms/MonthlyCostField.tsx
msgid "Free"
msgstr "Gratis"

#: src/modules/compute/VmView.tsx
#: src/modules/services/Backups.tsx
msgid "Frequency"
msgstr "Frekuensi"

#: src/modules/services/ServicesList.tsx
msgid "from"
msgstr "mulai dari"

#: src/modules/compute/VmCreate.tsx
msgid "From"
msgstr "Dari"

#. Billing account restriction level
#: src/modules/billing/statusHistory/statusHistoryLabels.tsx
msgid "Frozen"
msgstr ""

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Full path"
msgstr "Path lengkap"

#: src/modules/services/ServiceView.tsx
msgid "Fully managed database so you can focus on your code."
msgstr "Database yang dikelola sepenuhnya agar Anda dapat fokus pada kode Anda."

#: src/modules/api/resourceTypes.tsx
msgid "Fully managed services - we handle the provisioning of underlying infrastructure and the management of the service."
msgstr "Layanan terkelola sepenuhnya - kami menangani penyediaan infrastruktur dasar dan pengelolaan layanannya."

#. Metal coverage status
#: src/modules/metal/statusLabels.tsx
msgid "Future"
msgstr "Mendatang"

#. Payment gateway that the card is connected to
#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "Gateway"
msgstr "Gateway"

#. unit: gigabytes
#: src/components/forms/MonthlyCostField.tsx
#: src/modules/compute/DiskAddOrResizeModal.tsx
#: src/modules/compute/VmResizeModal.tsx
#: src/modules/disks/disk/DiskView.tsx
#: src/modules/disks/DiskList.tsx
#: src/modules/l10n/units.tsx
#: src/modules/services/Backups.tsx
#: src/modules/services/kubernetes/Infrastructure.tsx
#: src/modules/services/kubernetes/Infrastructure.tsx
#: src/modules/services/kubernetes/NodePoolsList.tsx
#: src/modules/services/kubernetes/NodePoolsList.tsx
msgid "GB"
msgstr "GB"

#. Example: 50 GB (of) disk
#: src/modules/l10n/units.tsx
msgid "GB disk"
msgstr "GB disk"

#. Example: 16 GB (of) RAM
#: src/modules/compute/VmSizeSelect.tsx
#: src/modules/l10n/units.tsx
msgid "GB RAM"
msgstr "GB RAM"

#. unit: gigabyte-hours (storage usage)
#: src/modules/l10n/units.tsx
msgid "GBh"
msgstr "GBh"

#. Explanation: Generate the subnet range automatically
#: src/modules/network/NetworkCreate.tsx
msgid "Generate (recommended)"
msgstr "Buat otomatis (disarankan)"

#: src/modules/access/AccessCreate.tsx
msgid "Generate an API access token to use our <0>API</0>."
msgstr "Buat token akses API untuk menggunakan <0>API</0> kami."

#: src/modules/access/scopeLabel.tsx
msgid "Global"
msgstr "Global"

#: src/modules/error/ErrorFallback.tsx
msgid "Go to dashboard"
msgstr "Ke dasbor"

#. Sales tax acronym in India
#: src/styles/hostzop/theme.tsx
msgid "GST"
msgstr "GST"

#. Sales tax acronym in India
#: src/styles/hostzop/theme.tsx
msgid "GST number"
msgstr "Nomor GST"

#. unit: hours
#: src/modules/l10n/units.tsx
msgid "h"
msgstr "j"

#. Chat widget greeting
#: src/modules/support/WChatProvider.tsx
msgid "Hello"
msgstr "Halo"

#: src/routes/_main_custom/about.lazy.tsx
msgid "Hello world!"
msgstr "Halo dunia!"

#: src/modules/services/ServiceView.tsx
#: src/modules/services/ServiceView.tsx
#: src/modules/services/ServiceView.tsx
msgid "Hibernate"
msgstr "Hibernasi"

#: src/modules/services/kubernetes/KubernetesStatusBadge.tsx
#: src/modules/services/ServicesList.tsx
msgid "Hibernated"
msgstr "Dihibernasikan"

#: src/modules/services/kubernetes/KubernetesStatusBadge.tsx
#: src/modules/services/ServicesList.tsx
msgid "Hibernating"
msgstr "Sedang dihibernasikan"

#. Button action
#: src/components/SecretKey.tsx
#: src/modules/services/TextSecret.tsx
msgid "Hide"
msgstr "Sembunyikan"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Hide details"
msgstr "Sembunyikan detail"

#: src/modules/api/resourceTypes.tsx
msgid "High availability load balancer distributes traffic between virtual machines within the same data center location."
msgstr "Load balancer high availability mendistribusikan lalu lintas antar mesin virtual dalam lokasi pusat data yang sama."

#. Time period unit
#: src/components/forms/MonthlyCostField.tsx
#: src/modules/metal/offer/period.tsx
msgid "hour"
msgstr "jam"

#. Server commitment period
#: src/modules/metal/offer/period.tsx
msgid "Hourly"
msgstr "Per jam"

#: src/modules/billing/LimitedBillingAccountNotice.tsx
msgid "Hourly billing cycle only"
msgstr "Hanya siklus penagihan per jam"

#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "Hourly updated usage for current billing period."
msgstr "Penggunaan untuk periode penagihan saat ini diperbarui setiap jam."

#: src/modules/dashboard/UserAccess.tsx
msgid "I can access"
msgstr "Akses diterima"

#: src/modules/login/ConsentForm.tsx
msgid "I have read and agree to the <0>Terms of Service</0>"
msgstr "Saya telah membaca dan menyetujui <0>Syarat dan Ketentuan Layanan</0>"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "I'm aware that deletion is permanent"
msgstr "Saya memahami bahwa penghapusan bersifat permanen"

#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "If low balance notifications are active and the balance falls below the threshold, you will be notified."
msgstr "Jika notifikasi saldo rendah aktif dan saldo turun di bawah ambang batas, Anda akan diberi tahu."

#: src/modules/metal/MetalLeaseDetailView.tsx
msgid "If the active reservation runs out and is not renewed then standard hourly based pricing will be applied."
msgstr "Jika reservasi aktif berakhir dan tidak diperpanjang, harga standar per jam akan diterapkan."

#: src/modules/billing/choose_method/InvoiceForm.tsx
msgid "If the invoice payment method is not activated instantly, we will contact you with more details. If you do not receive an email from us soon or the invoice payment does not become active, you can contact us at <0/>."
msgstr "Jika metode pembayaran faktur tidak langsung diaktifkan, kami akan menghubungi Anda dengan detail lebih lanjut. Jika Anda tidak segera menerima email dari kami atau pembayaran faktur tidak menjadi aktif, Anda dapat menghubungi kami di <0/>."

#: src/modules/dashboard/Dashboard.tsx
msgid "If you have any questions, found a bug or have a feature request feel free to contact us through <0>support</0>."
msgstr "Jika Anda memiliki pertanyaan, menemukan bug, atau memiliki permintaan fitur, silakan hubungi kami melalui <0>dukungan</0>."

#. Description for billing period field
#: src/modules/metal/offer/period.tsx
msgid "In all calculations a precise number of hours is used: 730 for a month, 2190 for a quarter and 8760 for a year."
msgstr "Dalam semua perhitungan, jumlah jam yang tepat digunakan: 730 untuk satu bulan, 2190 untuk satu triwulan, dan 8760 untuk satu tahun."

#: src/modules/metal/status/StatusLabels.tsx
msgid "In use"
msgstr "Digunakan"

#: src/modules/billing/BillingAccountInfo.tsx
msgid "Inactive"
msgstr "Tidak aktif"

#. Short of: inbound firewall rules
#: src/modules/network/NetworkList.tsx
msgid "inbound"
msgstr "masuk"

#: src/modules/compute/VmView.tsx
#: src/modules/network/firewall/FirewallView.tsx
#: src/modules/network/firewall/FirewallView.tsx
#: src/modules/network/NetworkCreate.tsx
msgid "Inbound rules"
msgstr "Aturan masuk"

#. The price has already been included in the virtual machine's price
#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "Included in VM price"
msgstr "Termasuk dalam harga VM"

#: src/modules/network/firewall/firewallLabels.tsx
msgid "Incoming traffic is allowed only to the specified ports if it originates from the specified sources. All other traffic will be blocked."
msgstr "Lalu lintas masuk hanya diizinkan ke port yang ditentukan jika berasal dari sumber yang ditentukan. Semua lalu lintas lainnya akan diblokir."

#: src/modules/compute/VmCreate.tsx
msgid "Informative name. It will also be used to generate a suitable hostname for the VM (if applicable)."
msgstr "Nama informatif. Nama ini juga akan digunakan untuk membuat hostname yang sesuai untuk VM (jika berlaku)."

#: src/modules/services/kubernetes/Infrastructure.tsx
#: src/modules/services/ServiceView.tsx
msgid "Infrastructure"
msgstr "Infrastruktur"

#: src/modules/compute/VmCreate.tsx
msgid "Initialization script"
msgstr "Skrip inisialisasi"

#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "Insert code"
msgstr "Masukkan kode"

#: src/modules/access/AccessCreate.tsx
msgid "Insert email of the {siteName} user you want to delegate access to. The user will need to accept the access invitation from their profile view."
msgstr "Masukkan email pengguna {siteName} yang ingin Anda beri delegasi akses. Pengguna tersebut perlu menerima undangan akses dari tampilan profil mereka."

#: src/modules/dashboard/BillingAccounts.tsx
msgid "Insufficient funds"
msgstr "Saldo tidak mencukupi"

#. Field label: identifier used to connect a billing account to an external integration
#. Unique ID number to integrate with external services
#: src/modules/billing/billingAccount/fieldsInfo.tsx
#: src/styles/defaultTheme.tsx
msgid "Integration ID"
msgstr "ID integrasi"

#. Card expiration validation error
#: src/modules/billing/omise/OmiseCardAddForm.tsx
msgid "Invalid month"
msgstr "Bulan tidak valid"

#: src/modules/api/ApiError.ts
msgid "Invalid response from server. Blocked by Stormwall."
msgstr "Respons dari server tidak valid. Diblokir oleh Stormwall."

#: src/modules/api/ApiError.ts
msgid "Invalid response type from server: Received {ct} instead of JSON."
msgstr "Jenis respons dari server tidak valid: menerima {ct} alih-alih JSON."

#: src/modules/login/auth0/Auth0Exception.ts
msgid "Invalid signup. The account may already exist."
msgstr "Pendaftaran tidak valid. Akun mungkin sudah ada."

#. Card expiration validation error
#: src/modules/billing/omise/OmiseCardAddForm.tsx
msgid "Invalid year"
msgstr "Tahun tidak valid"

#. What caused the billing account status change
#: src/modules/billing/invoice/DownloadPdf.tsx
#: src/modules/billing/statusHistory/statusHistoryLabels.tsx
msgid "Invoice"
msgstr "Faktur"

#: src/modules/billing/invoice/invoiceLogic.tsx
msgid "Invoice {id}"
msgstr "Faktur {id}"

#: src/modules/billing/billingAccount/BillingCreate.tsx
msgid "Invoice details"
msgstr "Detail faktur"

#: src/modules/billing/billingAccount/fieldsInfo.tsx
msgid "Invoice email"
msgstr "Email faktur"

#: src/modules/billing/payment/PaymentModal.tsx
msgid "Invoice has been paid"
msgstr "Faktur telah dibayar"

#: src/modules/billing/payment/PaymentModal.tsx
msgid "Invoice is not payable"
msgstr "Faktur tidak dapat dibayar"

#: src/modules/billing/InvoicePaymentInfo.tsx
msgid "Invoice name"
msgstr "Nama faktur"

#. What caused the billing account status change
#: src/modules/billing/statusHistory/statusHistoryLabels.tsx
msgid "Invoice payment"
msgstr ""

#: src/components/themeTrans.tsx
msgid "Invoices"
msgstr "Faktur"

#: src/modules/services/IpWhitelist.tsx
msgid "IP"
msgstr "IP"

#: src/modules/services/AddIpForm.tsx
msgid "IP address"
msgstr "Alamat IP"

#: src/modules/network/firewall/firewallLabels.tsx
msgid "IP address or CIDR range"
msgstr "Alamat IP atau rentang CIDR"

#. A list of IPs permitted to access the service | Legacy wording: IP whitelist
#: src/modules/services/IpWhitelist.tsx
#: src/modules/services/ServiceView.tsx
msgid "IP allowlist"
msgstr "Daftar IP yang diizinkan"

#: src/modules/network/firewall/ruleSpec.tsx
msgid "IP prefixes"
msgstr "Prefiks IP"

#: src/modules/network/NetworkCreate.tsx
msgid "IP range"
msgstr "Rentang IP"

#: src/modules/network/vpc/VpcView.tsx
msgid "IPv4 range"
msgstr "Rentang IPv4"

#: src/modules/network/vpc/VpcView.tsx
msgid "IPv6 range"
msgstr "Rentang IPv6"

#: src/modules/compute/BootFromIsoModal.tsx
msgid "ISO boot"
msgstr "Boot ISO"

#: src/modules/billing/invoice/InvoiceView.tsx
msgid "Issue date"
msgstr "Tanggal penerbitan"

#. Date the invoice was issued
#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "Issued"
msgstr "Diterbitkan"

#: src/modules/network/DeleteWithFloatingIp.tsx
msgid "Keep floating IP"
msgstr "Pertahankan Floating IP"

#: src/modules/user/ActAsModal.tsx
msgid "Keep in mind that all the actions will be tracked and can be traced back to you."
msgstr "Perlu diingat bahwa semua tindakan akan dilacak dan dapat ditelusuri kembali kepada Anda."

#: src/modules/storage/account/CreateKeyModal.tsx
#: src/modules/storage/account/UpdateKeyModal.tsx
msgid "Key name"
msgstr "Nama kunci"

#: src/modules/services/kubernetes/MaintenanceEditModal.tsx
msgid "Kubernetes Patch Version"
msgstr "Versi patch Kubernetes"

#: src/modules/services/kubernetes/Maintenance.tsx
msgid "Kubernetes Patch Version Auto update"
msgstr "Pembaruan otomatis versi patch Kubernetes"

#: src/modules/billing/LimitedBillingAccountNotice.tsx
msgid "Kubernetes service can not be created."
msgstr "Layanan Kubernetes tidak dapat dibuat."

#: src/modules/l10n/LocaleButton.tsx
msgid "Language"
msgstr "Bahasa"

#: src/modules/network/vpc/VpcView.tsx
msgid "Last modified"
msgstr "Terakhir diubah"

#: src/modules/user/ProfileView.tsx
msgid "Last name"
msgstr "Nama belakang"

#: src/modules/compute/VmView.tsx
msgid "Latest backup"
msgstr "Backup terbaru"

#. Timestamp of latest snapshot
#: src/modules/compute/VmView.tsx
#: src/modules/disks/disk/DiskView.tsx
#: src/modules/services/Backups.tsx
msgid "Latest snapshot"
msgstr "Snapshot terbaru"

#: src/modules/dashboard/StartSomethingNew.tsx
msgid "Less details"
msgstr "Lebih sedikit detail"

#: src/modules/main/ColorSchemeMenu.tsx
msgid "Light"
msgstr "Terang"

#: src/modules/billing/LimitedBillingAccountNotice.tsx
msgid "Limit will be removed once the total top up amount reaches <0/>."
msgstr "Batasan akan dihapus setelah total isi saldo mencapai <0/>."

#. Billing account restriction level
#: src/modules/billing/statusHistory/statusHistoryLabels.tsx
#: src/modules/dashboard/BillingAccounts.tsx
msgid "Limited"
msgstr "Terbatas"

#. Column title for invoice records' totals - record amount subtracted by discount
#: src/modules/billing/invoice/InvoiceView.tsx
msgid "Line total"
msgstr ""

#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "Linked resources"
msgstr "Sumber daya tertaut"

#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "list price"
msgstr "harga daftar"

#: src/modules/api/resourceTypes.tsx
msgid "Load balancer"
msgstr "Load balancer"

#. Button action: load the next rows of the list
#: src/modules/billing/statusHistory/StatusHistory.tsx
#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Load more"
msgstr "Muat lebih banyak"

#: src/modules/billing/progressLabels.tsx
msgid "Loading payment provider"
msgstr "Memuat penyedia pembayaran"

#: src/components/forms/WSelect.tsx
#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Loading..."
msgstr "Memuat..."

#: src/modules/compute/VmList.tsx
#: src/modules/disks/DiskList.tsx
#: src/modules/location/LocationDetail.tsx
#: src/modules/location/LocationField.tsx
#: src/modules/metal/MetalList.tsx
#: src/modules/network/NetworkList.tsx
#: src/modules/pricing/PricingModal.tsx
#: src/modules/services/ServicesList.tsx
msgid "Location"
msgstr "Lokasi"

#: src/modules/login/ApiKeyLogin.tsx
#: src/modules/login/auth0/Auth0Login.tsx
#: src/modules/login/Login.tsx
#: src/modules/login/Login.tsx
#: src/modules/login/LoginLayout.tsx
msgid "Log in"
msgstr "Masuk"

#: src/modules/login/Login.tsx
msgid "Log in with Google"
msgstr "Masuk dengan Google"

#: src/modules/main/LogoutConfirmDialog.tsx
#: src/modules/user/LogoutButton.tsx
#: src/modules/user/UserMenu.tsx
msgid "Log out"
msgstr "Keluar"

#: src/modules/login/auth0/Auth0Login.tsx
msgid "Logging in"
msgstr "Sedang masuk"

#: src/modules/login/auth0/Auth0Login.tsx
msgid "Login error"
msgstr "Kesalahan saat masuk"

#: src/modules/dashboard/WelcomeModal.tsx
msgid "Look around first"
msgstr "Lihat-lihat dulu"

#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "Low balance notification is not in effect because automated top up is activated."
msgstr "Notifikasi saldo rendah tidak berlaku karena isi saldo otomatis diaktifkan."

#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/LowBalanceNotificationsModal.tsx
msgid "Low balance notifications"
msgstr "Notifikasi saldo rendah"

#. MAC address
#: src/modules/compute/VmView.tsx
#: src/modules/compute/VmView.tsx
msgid "MAC"
msgstr "MAC"

#: src/modules/metal/MetalLeaseDetailView.tsx
msgid "Machine details"
msgstr "Detail mesin"

#: src/modules/metal/status/StatusLabels.tsx
msgid "Machine is available for immediate leasing by clients."
msgstr "Mesin tersedia untuk segera disewa oleh klien."

#: src/modules/metal/status/StatusLabels.tsx
msgid "Machine is being used by client and is being charged."
msgstr "Mesin sedang digunakan oleh klien dan dikenakan biaya."

#: src/modules/metal/status/StatusLabels.tsx
msgid "Machine is ordered by client, but does not satisfy the required configuration.<0/>After it has been configured as needed, move to “in use” status."
msgstr "Mesin telah dipesan oleh klien, tetapi belum memenuhi konfigurasi yang diperlukan.<0/>Setelah dikonfigurasi sesuai kebutuhan, pindahkan ke status “digunakan”."

#: src/modules/metal/status/StatusLabels.tsx
msgid "Machine is unavailable or requires repairs."
msgstr "Mesin tidak tersedia atau memerlukan perbaikan."

#: src/modules/metal/status/StatusLabels.tsx
msgid "Machine requires disk cleaning operations."
msgstr "Mesin memerlukan operasi pembersihan disk."

#: src/modules/services/kubernetes/Infrastructure.tsx
#: src/modules/services/kubernetes/NodePoolsList.tsx
msgid "Machine type"
msgstr "Tipe mesin"

#: src/modules/services/kubernetes/Maintenance.tsx
#: src/modules/services/kubernetes/MaintenanceEditModal.tsx
#: src/modules/services/ServiceView.tsx
msgid "Maintenance"
msgstr "Pemeliharaan"

#: src/modules/dashboard/UserAccess.tsx
#: src/modules/user/UserMenu.tsx
msgid "Manage"
msgstr "Kelola"

#: src/modules/dashboard/WelcomeBlock.tsx
msgid "Manage API keys"
msgstr "Kelola kunci API"

#: src/modules/api/resourceTypes.tsx
msgid "Managed service"
msgstr "Layanan terkelola"

#: src/modules/dashboard/StartSomethingNew.tsx
msgid "Managed services"
msgstr "Layanan terkelola"

#: src/modules/services/kubernetes/Infrastructure.tsx
#: src/modules/services/kubernetes/NodePoolsList.tsx
#: src/modules/services/kubernetes/NodeResizeModal.tsx
msgid "Max. surge"
msgstr "Lonjakan maks."

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Maximize"
msgstr "Perbesar"

#: src/modules/billing/forms/FileWithSourceInput.tsx
msgid "Maximum upload file size is {maxFileSizeInMB} MB"
msgstr "Ukuran file maksimum untuk diunggah adalah {maxFileSizeInMB} MB"

#. unit: megabytes
#: src/modules/l10n/units.tsx
msgid "MB"
msgstr "MB"

#. unit: megabytes per second
#: src/modules/l10n/units.tsx
msgid "MB/s"
msgstr "MB/dtk"

#. unit: megabits per second
#: src/modules/l10n/units.tsx
msgid "Mbit/s"
msgstr "Mbit/dtk"

#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/billingAccount/BillingCreate.tsx
msgid "Method"
msgstr "Metode"

#: src/modules/billing/billingAccount/BillingCreate.tsx
msgid "Methods available after validation"
msgstr "Metode yang tersedia setelah validasi"

#: src/modules/compute/VmView.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/services/Metrics.tsx
#: src/modules/services/ServiceView.tsx
msgid "Metrics"
msgstr "Metrik"

#: src/modules/compute/monitor/MetricChart.tsx
msgid "Metrics for this resource are not loaded for performance reasons"
msgstr "Metrik untuk sumber daya ini tidak dimuat demi alasan performa"

#: src/modules/user/ProfileView.tsx
msgid "MFA is active for your user."
msgstr "MFA aktif untuk pengguna Anda."

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Minimize"
msgstr "Perkecil"

#. The selected item was not found
#: src/components/forms/WSelect.tsx
msgid "Missing"
msgstr "Tidak ditemukan"

#. If the disk is a boot disk
#: src/modules/compute/VmView.tsx
msgid "Mode"
msgstr "Mode"

#. Time period unit
#: src/components/forms/MonthlyCostField.tsx
#: src/modules/metal/offer/MetalOfferSection.tsx
#: src/modules/metal/offer/period.tsx
msgid "month"
msgstr "bulan"

#. Server commitment period
#: src/modules/metal/offer/period.tsx
msgid "Monthly"
msgstr "Bulanan"

#: src/components/sidebar/PriceBlock.tsx
#: src/modules/disks/DiskList.tsx
#: src/modules/services/ServicesList.tsx
#: src/modules/storage/StorageList.tsx
msgid "Monthly cost"
msgstr "Biaya bulanan"

#: src/modules/dashboard/StartSomethingNew.tsx
msgid "More details"
msgstr "Lebih banyak detail"

#: src/modules/user/ProfileView.tsx
msgid "Multi-factor authentication (MFA)"
msgstr "Autentikasi multifaktor (MFA)"

#: src/modules/billing/forms/BillingSelect.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/network/firewall/FirewallView.tsx
msgid "N/A"
msgstr "Tidak berlaku"

#: src/components/table/DetailsTableName.tsx
#: src/modules/access/AccessList.tsx
#: src/modules/access/delegation/DelegationView.tsx
#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/BillingList.tsx
#: src/modules/compute/AddSshKeyModal.tsx
#: src/modules/compute/UpdateSshKeyModal.tsx
#: src/modules/compute/VmList.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/disks/DiskList.tsx
#: src/modules/metal/MetalList.tsx
#: src/modules/network/firewall/AssignedToList.tsx
#: src/modules/network/firewall/FirewallView.tsx
#: src/modules/network/loadbalancer/LoadBalancerView.tsx
#: src/modules/network/loadbalancer/TargetServersList.tsx
#: src/modules/network/NetworkList.tsx
#: src/modules/network/vpc/VpcView.tsx
#: src/modules/services/kubernetes/NodeResizeModal.tsx
#: src/modules/services/ServicesList.tsx
#: src/modules/storage/account/StorageAccountView.tsx
#: src/modules/storage/account/StorageAccountView.tsx
#: src/modules/storage/bucket/BucketView.tsx
#: src/modules/storage/StorageList.tsx
#: src/modules/user/ProfileView.tsx
#: src/modules/user/ProfileView.tsx
msgid "Name"
msgstr "Nama"

#: src/modules/billing/payment_forms/components.tsx
msgid "Name (Min {minChars} chars)"
msgstr "Nama (Min. {minChars} karakter)"

#: src/modules/billing/payment_forms/components.tsx
msgid "Name is too short"
msgstr "Nama terlalu pendek"

#: src/modules/support/WChatProvider.tsx
msgid "Need help?"
msgstr "Butuh bantuan?"

#: src/modules/api/resourceTypes.tsx
#: src/modules/main/sidebar/Sidebar.sections.tsx
#: src/modules/network/NetworkList.tsx
msgid "Network"
msgstr "Jaringan"

#: src/modules/compute/MetricsGrid.tsx
msgid "Network bandwidth"
msgstr "Bandwidth jaringan"

#: src/modules/compute/VmView.tsx
msgid "Network interfaces"
msgstr "Antarmuka jaringan"

#: src/modules/compute/VmView.tsx
#: src/modules/services/ServiceView.tsx
msgid "Networking"
msgstr "Jaringan"

#. Table column: value after the change
#: src/components/sidebar/SidebarList.tsx
#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/network/NetworkList.tsx
msgid "New"
msgstr "Baru"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "New file name"
msgstr "Nama file baru"

#: src/modules/storage/s3/S3FileBrowser.tsx
#: src/modules/storage/s3/S3FileBrowser.tsx
#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "New folder"
msgstr "Folder baru"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "New folder name"
msgstr "Nama folder baru"

#: src/modules/network/VpcNetworkSelect.tsx
msgid "New network"
msgstr "Jaringan baru"

#: src/modules/compute/PasswordFields.tsx
msgid "New password"
msgstr "Kata sandi baru"

#: src/modules/compute/AddSshKeyModal.tsx
msgid "New SSH key"
msgstr "Kunci SSH baru"

#: src/styles/nforce/theme.tsx
msgid "NForce customer ID"
msgstr "ID pelanggan NForce"

#: src/modules/billing/BillingAccountInfo.tsx
msgid "No active card"
msgstr "Tidak ada kartu aktif"

#. Chart empty state: no metric samples are available
#: src/modules/compute/monitor/MetricChart.tsx
msgid "No data"
msgstr "Tidak ada data"

#. Fail-over is disabled, no fail-over nodes
#: src/modules/services/FailoverNodeSelect.tsx
msgid "No Fail-over"
msgstr "Tanpa fail-over"

#. Shown when the billing account status history is empty
#: src/modules/billing/statusHistory/statusHistoryLabels.tsx
msgid "No history available."
msgstr ""

#: src/modules/dashboard/UserAccess.tsx
msgid "No one can access your user account yet"
msgstr "Belum ada yang dapat mengakses akun pengguna Anda"

#: src/modules/dashboard/UserAccess.tsx
msgid "No one has shared access with you yet"
msgstr "Belum ada yang membagikan akses kepada Anda"

#: src/modules/billing/billingAccount/BillingCreate.tsx
msgid "No payment will be made currently. You can change your payment method at any time."
msgstr "Saat ini tidak ada pembayaran yang akan dilakukan. Anda dapat mengubah metode pembayaran kapan saja."

#: src/components/empty.tsx
msgid "No records"
msgstr "Tidak ada data"

#: src/modules/metal/offer/MetalOfferSection.tsx
msgid "No reservation billing cycles are available for this server."
msgstr "Tidak ada siklus penagihan reservasi yang tersedia untuk server ini."

#: src/modules/billing/statusHistory/statusHistoryLabels.tsx
msgid "No restrictions"
msgstr ""

#: src/components/sidebar/EmptyItem.tsx
#: src/modules/dashboard/AppCatalog.tsx
#: src/modules/dashboard/ManagedServices.tsx
msgid "No results found"
msgstr "Tidak ada hasil ditemukan"

#: src/modules/billing/statusHistory/StatusHistory.tsx
msgid "No verified primary payment method"
msgstr ""

#. Short of: Number of storage buckets
#: src/modules/storage/account/StorageAccountView.tsx
msgid "No. of buckets"
msgstr "Jml. bucket"

#: src/modules/storage/account/StorageAccountView.tsx
#: src/modules/storage/bucket/BucketView.tsx
msgid "No. of files"
msgstr "Jml. file"

#. Short of: Number of resources
#: src/modules/compute/VmView.tsx
#: src/modules/network/firewall/FirewallView.tsx
#: src/modules/network/NetworkList.tsx
#: src/modules/network/NetworkList.tsx
msgid "No. of resources"
msgstr "Jumlah sumber daya"

#: src/modules/compute/VmView.tsx
#: src/modules/network/firewall/FirewallView.tsx
msgid "No. of rules"
msgstr "Jumlah aturan"

#: src/modules/services/Backups.tsx
#: src/modules/services/Metrics.tsx
msgid "Node"
msgstr "Node"

#: src/modules/services/kubernetes/Infrastructure.tsx
#: src/modules/services/kubernetes/NodePoolsList.tsx
msgid "Node pool"
msgstr "Node pool"

#: src/modules/services/ServiceCreate.tsx
msgid "Node pools"
msgstr "Node pool"

#: src/modules/services/kubernetes/KubernetesReadynessBadge.tsx
msgid "nodes"
msgstr "node"

#. Items: means files or folders
#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Note: If you are deleting substantial number of items, the deletion process may result in an inconsistent state, where some items are deleted while others remain. In the event of such occurrences, please repeat the same action again."
msgstr "Catatan: Jika Anda menghapus sangat banyak item, proses penghapusan dapat mengakibatkan keadaan yang tidak konsisten, di mana beberapa item terhapus sementara yang lainnya tetap ada. Jika hal ini terjadi, silakan ulangi tindakan yang sama sekali lagi."

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Note: If your folder contains a substantial number of files, the renaming process will take time and may result in an inconsistent state where some files are moved to a new location, while others remain in the old folder. In the event of such occurrences, please repeat the action by renaming the same folder once more."
msgstr "Catatan: Jika folder Anda berisi sangat banyak file, proses penggantian nama akan memerlukan waktu dan dapat mengakibatkan keadaan yang tidak konsisten, di mana beberapa file dipindahkan ke lokasi baru, sementara yang lainnya tetap berada di folder lama. Jika hal ini terjadi, silakan ulangi tindakan tersebut dengan mengganti nama folder yang sama sekali lagi."

#: src/modules/access/AcceptInvitationModal.tsx
msgid "Note! The owner will know if you have accepted this invitation. They will not be able to access your user account and see or edit any of your resources."
msgstr "Perhatian! Pemilik akan mengetahui jika Anda telah menerima undangan ini. Mereka tidak akan dapat mengakses akun pengguna Anda maupun melihat atau mengubah sumber daya Anda."

#: src/modules/notifications/NotificationMenu.tsx
msgid "Notifications"
msgstr "Notifikasi"

#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "Notify when balance goes below"
msgstr "Beri tahu saat saldo turun di bawah"

#: src/modules/billing/LowBalanceNotificationsModal.tsx
msgid "Notify when balance goes below the following threshold. Keep in mind that the actual limit is defined in base currency."
msgstr "Kirim notifikasi saat saldo turun di bawah ambang batas berikut. Perlu diingat bahwa batas sebenarnya ditentukan dalam mata uang dasar."

#. Availability announcement for AMD EPYC cloud resources
#: src/styles/readyidc/theme.tsx
msgid "Now available"
msgstr "Kini tersedia"

#: src/modules/metal/status/StatusLabels.tsx
msgid "Offline"
msgstr "Offline"

#. Table column: value before the change
#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "Old"
msgstr ""

#. Backup frequency
#: src/modules/services/Backups.tsx
msgid "Once a day"
msgstr "Sekali sehari"

#: src/modules/compute/VmView.tsx
msgid "Once a week (Wednesday at 02:00 UTC)"
msgstr "Seminggu sekali (Rabu pukul 02.00 UTC)"

#: src/modules/storage/account/SuspendedNotice.tsx
msgid "One of your billing accounts has a problem and your buckets have been suspended. See <0>billing account details</0> for more information or contact support to resolve the issue."
msgstr "Salah satu akun penagihan Anda mengalami masalah dan bucket Anda telah ditangguhkan. Lihat <0>detail akun penagihan</0> untuk informasi lebih lanjut atau hubungi dukungan untuk menyelesaikan masalah ini."

#: src/modules/billing/BillingList.tsx
#: src/modules/billing/ReportStatus.tsx
msgid "Ongoing"
msgstr "Berlangsung"

#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/dashboard/BillingAccounts.tsx
msgid "Ongoing balance"
msgstr "Saldo berjalan"

#: src/modules/services/kubernetes/KubernetesStatusBadge.tsx
msgid "Online"
msgstr "Online"

#. Only payment methods that can be charged automatically
#: src/modules/billing/choose_method/ChooseMethod.tsx
msgid "Only automated methods"
msgstr "Hanya metode otomatis"

#: src/modules/compute/VmCreate.tsx
msgid "Only the boot disk will be created! This may cause the OS to not boot properly if the configuration in the OS of source snapshot requires additional disks to be present."
msgstr "Hanya disk boot yang akan dibuat! Hal ini dapat menyebabkan OS tidak dapat melakukan boot dengan benar jika konfigurasi dalam OS dari snapshot sumber mengharuskan adanya disk tambahan."

#: src/modules/compute/labels.tsx
#: src/modules/services/kubernetes/MaintenanceEditModal.tsx
msgid "Operating system"
msgstr "Sistem operasi"

#: src/modules/services/kubernetes/Maintenance.tsx
msgid "Operating system Auto update"
msgstr "Pembaruan otomatis sistem operasi"

#: src/modules/login/Login.tsx
msgid "Or"
msgstr "Atau"

#: src/styles/dataxion/theme.tsx
msgid "Order"
msgstr "Pesanan"

#: src/styles/dataxion/theme.tsx
msgid "Orders"
msgstr "Pesanan"

#. Short of: Operating system
#: src/modules/compute/ReinstallModal.tsx
#: src/modules/compute/VmCreate.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/metal/MetalCreate.tsx
#: src/modules/metal/MetalLeaseDetailView.tsx
msgid "OS"
msgstr "OS"

#. Short of: outbound firewall rules
#: src/modules/network/NetworkList.tsx
msgid "outbound"
msgstr "keluar"

#: src/modules/compute/VmView.tsx
#: src/modules/network/firewall/FirewallView.tsx
#: src/modules/network/firewall/FirewallView.tsx
#: src/modules/network/NetworkCreate.tsx
msgid "Outbound rules"
msgstr "Aturan keluar"

#: src/modules/network/firewall/firewallLabels.tsx
msgid "Outgoing traffic is allowed only to the specified ports of the specified destinations. All other traffic will be blocked."
msgstr "Lalu lintas keluar hanya diizinkan ke port yang ditentukan pada tujuan yang ditentukan. Semua lalu lintas lainnya akan diblokir."

#: src/modules/billing/BillingList.tsx
msgid "Outstanding amount"
msgstr "Jumlah terutang"

#: src/modules/billing/ReportStatus.tsx
msgid "Paid"
msgstr "Lunas"

#: src/modules/services/ConnectionDetails.tsx
msgid "Parameters"
msgstr "Parameter"

#: src/modules/compute/PasswordFields.tsx
#: src/modules/login/auth0/Auth0Login.tsx
#: src/modules/user/ProfileView.tsx
msgid "Password"
msgstr "Kata sandi"

#: src/modules/compute/PasswordFields.tsx
msgid "Password for the user. Must contain at least one lowercase and one uppercase ASCII letter (a-z, A-Z) and at least one digit (0-9). Minimum length is 8 characters."
msgstr "Kata sandi untuk pengguna. Harus berisi setidaknya satu huruf kecil dan satu huruf besar ASCII (a-z, A-Z), serta setidaknya satu angka (0-9). Panjang minimal 8 karakter."

#: src/modules/compute/PasswordFields.tsx
msgid "Passwords do not match"
msgstr "Kata sandi tidak cocok"

#. Metal coverage status
#: src/modules/metal/statusLabels.tsx
msgid "Past"
msgstr "Lampau"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Path style URL"
msgstr "URL gaya path"

#. Button action: pay for unpaid invoice
#: src/modules/billing/ActionButtons.tsx
msgid "Pay"
msgstr "Bayar"

#: src/modules/billing/payment/PaymentModal.tsx
#: src/modules/billing/payment/PaymentModal.tsx
msgid "Pay invoice"
msgstr "Bayar faktur"

#: src/modules/billing/invoice/InvoiceView.tsx
msgid "Pay now"
msgstr "Bayar sekarang"

#: src/modules/billing/evc_hormuud/EvcHormuudPaymentForm.tsx
msgid "Pay the total charge amount of <0>{chargeAmount}</0> with EVC Mobile Money to get {creditAmount} credits. Enter your billing account ID <1>{billingAccountId}</1> as the payment reference."
msgstr ""

#: src/modules/billing/billingAccount/BillingCreate.tsx
msgid "Pay-as-you-go (recommended)"
msgstr "Bayar sesuai pemakaian (disarankan)"

#: src/modules/billing/BillingAccountInfo.tsx
#: src/modules/billing/paymentMethodLogic.tsx
#: src/modules/billing/statusHistory/statusHistoryLabels.tsx
msgid "Paying by invoice"
msgstr "Pembayaran dengan faktur"

#: src/modules/billing/BillingAccountInfo.tsx
msgid "Paying by invoice (declined / suspended)"
msgstr "Pembayaran dengan faktur (ditolak / ditangguhkan)"

#: src/modules/billing/BillingAccountInfo.tsx
msgid "Paying by invoice (pending)"
msgstr "Pembayaran dengan faktur (tertunda)"

#: src/modules/billing/PaymentReturn.tsx
msgid "Payment authorization check finished."
msgstr "Pemeriksaan otorisasi pembayaran selesai."

#: src/modules/billing/sslcommerz/parseSslcommerzPersistentData.ts
msgid "Payment cancelled"
msgstr "Pembayaran dibatalkan"

#: src/modules/billing/sslcommerz/parseSslcommerzPersistentData.ts
msgid "Payment cancelled due to high risk"
msgstr "Pembayaran dibatalkan karena risiko tinggi"

#: src/modules/billing/billingAccount/BillingCreate.tsx
msgid "Payment details"
msgstr "Detail pembayaran"

#: src/modules/billing/payment/PaymentModal.tsx
msgid "Payment error"
msgstr "Kesalahan pembayaran"

#: src/modules/billing/payment/paymentUtils.ts
msgid "Payment error: {failure_message}{codeSuffix}"
msgstr "Kesalahan pembayaran: {failure_message}{codeSuffix}"

#: src/modules/billing/clictopay/parseClictopayPaymentResult.ts
#: src/modules/billing/coingate/parseCoingatePaymentResult.ts
#: src/modules/billing/paypal/parsePaypalCheckoutPaymentResult.tsx
#: src/modules/billing/razorpay/parseRazorpayPersistentData.ts
msgid "Payment failed"
msgstr "Pembayaran gagal"

#. What caused the billing account status change
#: src/modules/billing/billingAccount/BillingCreate.tsx
#: src/modules/billing/payment/PaymentModal.tsx
#: src/modules/billing/statusHistory/statusHistoryLabels.tsx
msgid "Payment method"
msgstr "Metode pembayaran"

#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "Payment methods"
msgstr "Metode pembayaran"

#: src/modules/billing/payment_forms/components.tsx
msgid "Payment processing with this method takes some time. Purchased credit will be automatically added to your account once the process is complete."
msgstr "Pemrosesan pembayaran dengan metode ini memerlukan waktu. Kredit yang dibeli akan otomatis ditambahkan ke akun Anda setelah proses selesai."

#: src/modules/billing/billingAccount/BillingCreate.tsx
msgid "Payment type"
msgstr "Jenis pembayaran"

#: src/modules/billing/payment/PaymentModal.tsx
msgid "Payment was cancelled"
msgstr "Pembayaran dibatalkan"

#. unit: pieces
#: src/modules/l10n/units.tsx
msgid "pc"
msgstr "buah"

#: src/modules/access/delegation/DelegationView.tsx
#: src/modules/dashboard/RecentlyModified.tsx
#: src/modules/dashboard/RecentlyModified.tsx
#: src/modules/dashboard/UserAccess.tsx
#: src/modules/metal/status/StatusLabels.tsx
#: src/modules/user/ProfileView.tsx
msgid "Pending"
msgstr "Tertunda"

#. Billing account status
#: src/modules/billing/statusHistory/statusHistoryLabels.tsx
msgid "Pending validation"
msgstr ""

#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/invoice/InvoiceView.tsx
msgid "Period"
msgstr "Periode"

#: src/modules/storage/account/StorageAccountView.tsx
#: src/modules/storage/s3/S3FileBrowser.tsx
#: src/modules/storage/s3/S3FileBrowser.tsx
#: src/modules/storage/s3/S3FileBrowser.tsx
#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Permissions"
msgstr "Izin"

#: src/modules/billing/billingAccount/fieldsInfo.tsx
msgid "Personal ID number"
msgstr "Nomor identitas pribadi"

#: src/modules/billing/omise/OmisePaymentForm.tsx
#: src/modules/billing/sslcommerz/SslcommerzPaymentForm.tsx
msgid "Phone number"
msgstr "Nomor telepon"

#: src/modules/compute/BootFromIsoModal.tsx
msgid "Platform provided"
msgstr "Disediakan platform"

#: src/modules/billing/choose_method/invoiceMethodLogic.tsx
msgid "Please acknowledge that billing account will not be activated before an administrator has accepted your request."
msgstr "Harap pahami bahwa akun penagihan tidak akan diaktifkan sebelum administrator menyetujui permintaan Anda."

#: src/modules/billing/choose_method/useAddMethod.tsx
msgid "Please allow popup windows to use this payment method"
msgstr "Silakan izinkan jendela popup untuk menggunakan metode pembayaran ini"

#: src/modules/billing/payment/PaymentModal.tsx
msgid "Please be patient"
msgstr "Mohon bersabar"

#: src/modules/billing/progressLabels.tsx
msgid "Please complete the payment in the popup window"
msgstr "Silakan selesaikan pembayaran di jendela popup"

#: src/modules/billing/LimitedBillingAccountNotice.tsx
msgid "Please contact support to remove the limit."
msgstr "Silakan hubungi dukungan untuk menghapus batasan ini."

#: src/modules/billing/account_validation/digio/DigioBaValidationBlock.tsx
msgid "Please contact the administrators for further details."
msgstr "Silakan hubungi administrator untuk detail lebih lanjut."

#: src/modules/billing/account_validation/digio/DigioBaValidationBlock.tsx
msgid "Please continue."
msgstr "Silakan lanjutkan."

#: src/modules/storage/account/CreateBucketModal.tsx
msgid "Please enter a valid name"
msgstr "Harap masukkan nama yang valid"

#: src/modules/login/Login.tsx
msgid "Please enter your email address. We will send you an email to reset your password."
msgstr "Silakan masukkan alamat email Anda. Kami akan mengirimkan email untuk mengatur ulang kata sandi Anda."

#: src/modules/access/AccessCreate.tsx
msgid "Please finish adding the email"
msgstr "Harap selesaikan penambahan email"

#: src/modules/storage/bucket/bucketMessages.tsx
msgid "Please note that the billing account linked to your storage bucket differs from the one associated with your storage account. We highly recommend aligning them for billing consistency and clearer management."
msgstr "Harap perhatikan bahwa akun penagihan yang terhubung ke bucket penyimpanan Anda berbeda dengan akun yang terkait dengan akun penyimpanan Anda. Kami sangat menyarankan agar keduanya diselaraskan demi konsistensi penagihan dan pengelolaan yang lebih jelas."

#: src/components/forms/MonthlyCostField.tsx
msgid "Please see how the cost of your resource is calculated."
msgstr "Silakan lihat cara biaya resource Anda dihitung."

#: src/modules/network/loadbalancer/TargetServersList.tsx
msgid "Please select a VPC network to choose target servers from."
msgstr "Silakan pilih jaringan VPC untuk memilih server target."

#: src/modules/billing/choose_method/AddPaymentMethodModal.tsx
msgid "Please select an item in the list"
msgstr "Silakan pilih item dalam daftar"

#: src/modules/billing/billingAccount/BillingCreate.tsx
msgid "Please upload a copy of the business registration document or ID card for verification (max {maxFileSizeInMB}MB)."
msgstr "Silakan unggah salinan dokumen pendaftaran perusahaan atau kartu identitas untuk verifikasi (maks. {maxFileSizeInMB}MB)."

#: src/modules/services/ServiceView.tsx
msgid "Pods and services hosted on this cluster will be stopped and any ephemeral storage will be discarded."
msgstr "Pod dan layanan yang dihosting di cluster ini akan dihentikan dan semua penyimpanan ephemeral akan dibuang."

#: src/modules/billing/popup/popup.ts
msgid "Popup did not return from redirect"
msgstr "Popup tidak kembali setelah pengalihan"

#: src/modules/billing/popup/popup.ts
msgid "Popup was closed before it could load"
msgstr "Popup ditutup sebelum berhasil dimuat"

#: src/modules/network/loadbalancer/ForwardingRulesList.tsx
#: src/modules/network/loadbalancer/LoadBalancerView.tsx
msgid "Port"
msgstr "Port"

#: src/modules/network/validatePort.ts
msgid "Port must be between 1 and 65535"
msgstr "Port harus berada di antara 1 dan 65535"

#: src/modules/compute/VmView.tsx
#: src/modules/network/firewall/FirewallView.tsx
#: src/modules/network/firewall/RulesList.tsx
msgid "Port range"
msgstr "Rentang port"

#: src/modules/services/ServiceCreate.tsx
msgid "PostgreSQL multi-node setup is a Primary/Standby setup with automatic fail-over."
msgstr "Penyiapan PostgreSQL multi-node adalah penyiapan Primary/Standby dengan fail-over otomatis."

#. Resources attached to the billing account that have already been paid for
#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "Pre-paid resources"
msgstr "Sumber daya prabayar"

#: src/modules/billing/BillingAccountInfo.tsx
msgid "Pre-payment"
msgstr "Pembayaran di muka"

#: src/modules/compute/VmList.tsx
msgid "Price"
msgstr "Harga"

#: src/modules/compute/VmCreate.tsx
#: src/modules/pricing/PricingModal.tsx
msgid "Price list"
msgstr "Daftar harga"

#: src/modules/metal/MetalLeaseDetailView.tsx
msgid "Price per cycle"
msgstr "Harga per siklus"

#: src/modules/pricing/PricingModal.tsx
msgid "Price per hour"
msgstr "Harga per jam"

#: src/modules/pricing/PricingModal.tsx
msgid "Price per month"
msgstr "Harga per bulan"

#: src/modules/pricing/PricingModal.tsx
msgid "Prices may vary for the options below"
msgstr "Harga dapat berbeda untuk opsi di bawah ini"

#. The card that is selected for automatic charging (ie. main)
#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/compute/VmView.tsx
msgid "Primary"
msgstr "Utama"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Private"
msgstr "Privat"

#: src/modules/compute/BootFromIsoModal.tsx
msgid "Private images"
msgstr "Image privat"

#: src/modules/network/firewall/AssignedToList.tsx
#: src/modules/network/firewall/FirewallView.tsx
#: src/modules/network/loadbalancer/LoadBalancerView.tsx
#: src/modules/network/loadbalancer/TargetServersList.tsx
msgid "Private IP"
msgstr "IP privat"

#: src/modules/compute/VmView.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/network/loadbalancer/LoadBalancerView.tsx
#: src/modules/network/vpc/VpcView.tsx
#: src/modules/services/Networking.tsx
#: src/modules/services/ServiceView.tsx
msgid "Private IPv4"
msgstr "IPv4 privat"

#: src/modules/services/Networking.tsx
msgid "Private network"
msgstr "Jaringan privat"

#: src/modules/billing/paypal/PaypalVaultAddForm.tsx
#: src/modules/billing/paypal/PaypalVaultAddForm.tsx
msgid "Problem with PayPal API."
msgstr "Terjadi masalah dengan API PayPal."

#: src/modules/user/ProfileView.tsx
#: src/modules/user/UserMenu.tsx
msgid "Profile"
msgstr "Profil"

#: src/modules/compute/VmView.tsx
#: src/modules/network/firewall/EditRuleModal.tsx
#: src/modules/network/firewall/FirewallView.tsx
#: src/modules/network/firewall/RulesList.tsx
#: src/modules/network/loadbalancer/ForwardingRulesList.tsx
#: src/modules/network/loadbalancer/LoadBalancerView.tsx
msgid "Protocol"
msgstr "Protokol"

#: src/modules/compute/VmCreate.tsx
msgid "Provide a valid cloud-config as JSON or YAML. This configuration will be passed as cloud-init user-data to the virtual machine. See cloud-init documentation about cloud-config for all the available options."
msgstr "Masukkan cloud-config yang valid dalam format JSON atau YAML. Konfigurasi ini akan diteruskan sebagai user-data cloud-init ke mesin virtual. Lihat dokumentasi cloud-init tentang cloud-config untuk semua opsi yang tersedia."

#: src/modules/services/kubernetes/MaintenanceEditModal.tsx
msgid "Provider start of maintenance time window in which Provider may schedule automated cluster updates."
msgstr "Waktu mulai jendela pemeliharaan penyedia, yaitu waktu saat penyedia dapat menjadwalkan pembaruan cluster otomatis."

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Public"
msgstr "Publik"

#: src/components/table/DetailsTableIpAddress.tsx
msgid "Public IP addresses are managed in the Network view."
msgstr "Alamat IP publik dikelola di tampilan Jaringan."

#: src/components/table/DetailsTableIpAddress.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/metal/MetalLeaseDetailView.tsx
#: src/modules/network/CreateAndAssignIpField.tsx
#: src/modules/network/ipAddress/IpAddressView.tsx
#: src/modules/network/vpc/VpcView.tsx
msgid "Public IPv4"
msgstr "IPv4 publik"

#: src/modules/compute/VmView.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/metal/MetalLeaseDetailView.tsx
#: src/modules/network/vpc/VpcView.tsx
msgid "Public IPv6"
msgstr "IPv6 publik"

#: src/modules/compute/AddSshKeyModal.tsx
#: src/modules/user/ProfileView.tsx
msgid "Public key"
msgstr "Kunci publik"

#: src/modules/compute/labels.tsx
msgid "Public key part of the SSH key pair for logging in to the VM. Must be in format <0>ssh-key-type base64encoded...key optional_comment</0>."
msgstr "Bagian kunci publik dari pasangan kunci SSH untuk login ke VM. Harus dalam format <0>ssh-key-type base64encoded...key optional_comment</0>."

#: src/modules/services/ConnectionDetails.tsx
msgid "Public network"
msgstr "Jaringan publik"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Public URL"
msgstr "URL publik"

#. Short of: Quantity
#: src/modules/billing/invoice/InvoiceView.tsx
msgid "Qty."
msgstr "Jml."

#. Time period unit
#: src/modules/metal/offer/period.tsx
msgid "quarter"
msgstr "triwulan"

#. Server commitment period
#: src/modules/metal/offer/period.tsx
msgid "Quarterly"
msgstr "Triwulanan"

#: src/modules/billing/LimitedBillingAccountNotice.tsx
#: src/modules/compute/MetricsGrid.tsx
msgid "RAM"
msgstr "RAM"

#: src/modules/compute/VmToolbar.tsx
msgid "RDP link"
msgstr "Tautan RDP"

#: src/modules/services/ServiceView.tsx
msgid "Read more"
msgstr "Baca selengkapnya"

#. Only read permissions
#: src/modules/storage/account/CreateKeyModal.tsx
#: src/modules/storage/account/StorageAccountView.tsx
msgid "Read-only"
msgstr "Hanya baca"

#: src/modules/services/ServiceView.tsx
msgid "Readiness"
msgstr "Kesiapan"

#: src/modules/metal/os/MetalOsSelect.tsx
msgid "Ready"
msgstr "Siap"

#. Table column: why the restriction level changed
#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "Reason"
msgstr ""

#: src/modules/compute/VmToolbar.tsx
#: src/modules/compute/VmToolbar.tsx
#: src/modules/compute/VmToolbar.tsx
msgid "Reboot"
msgstr "Mulai ulang"

#: src/modules/dashboard/RecentlyModified.tsx
msgid "Recent"
msgstr "Terbaru"

#: src/modules/billing/progressLabels.tsx
msgid "Redirecting to payment gateway"
msgstr "Mengalihkan ke gateway pembayaran"

#: src/modules/billing/referral/ReferralProgram.tsx
msgid "Referral code"
msgstr "Kode referral"

#: src/modules/billing/referral/ReferralProgram.tsx
msgid "Referral link"
msgstr "Tautan referral"

#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/referral/ReferralProgram.tsx
msgid "Referral program"
msgstr "Program referral"

#: src/modules/billing/evc_hormuud/EvcHormuudPaymentForm.tsx
msgid "Refresh credit"
msgstr ""

#: src/modules/billing/account_validation/RefreshStatusButton.tsx
msgid "Refresh status"
msgstr "Segarkan status"

#: src/modules/billing/billingAccount/fieldsInfo.tsx
msgid "Registration number"
msgstr "Nomor registrasi"

#: src/modules/compute/ReinstallModal.tsx
#: src/modules/compute/ReinstallModal.tsx
#: src/modules/compute/ReinstallModal.tsx
msgid "Reinstall"
msgstr "Instal ulang"

#: src/modules/compute/ReinstallModal.tsx
msgid "Reinstalling \"{name}\" will destroy all data on the boot disk and set it to the initial clean OS state. All snapshots and backups are preserved."
msgstr "Menginstal ulang \"{name}\" akan menghapus semua data pada disk boot dan mengembalikannya ke kondisi awal OS yang bersih. Semua snapshot dan cadangan akan tetap disimpan."

#: src/components/sidebar/ListErrorBoundary.tsx
msgid "Reload"
msgstr "Muat ulang"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Reload data"
msgstr "Muat ulang data"

#: src/root.tsx
msgid "Reload page"
msgstr "Muat ulang halaman"

#: src/modules/billing/PaymentTopItem.tsx
msgid "Remaining credit <0/>"
msgstr "Sisa kredit <0/>"

#: src/modules/network/firewall/FirewallView.tsx
msgid "Remove resource"
msgstr "Lepas resource"

#: src/modules/network/ipAddress/IpAddressView.tsx
msgid "Removing the public IPv4 address assignment from this resource will make the resource inaccessible from the public Internet. The IP address will remain reserved to your account. You can manage public IPv4 addresses from the Network menu on the left sidebar."
msgstr "Menghapus penetapan alamat IPv4 publik dari resource ini akan membuat resource tidak dapat diakses dari Internet publik. Alamat IP tersebut akan tetap dicadangkan untuk akun Anda. Anda dapat mengelola alamat IPv4 publik dari menu Jaringan di bilah sisi kiri."

#. placeholder {0}: item.grantee_username
#: src/modules/access/delegation/DelegationView.tsx
msgid "Removing user will revoke the rights from \"{0}\" to act as you."
msgstr "Menghapus pengguna akan mencabut hak \"{0}\" untuk bertindak sebagai Anda."

#: src/modules/storage/s3/S3FileBrowser.tsx
#: src/modules/storage/s3/S3FileBrowser.tsx
#: src/modules/storage/s3/S3FileBrowser.tsx
#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Rename"
msgstr "Ubah nama"

#: src/modules/billing/invoice/DownloadPdf.tsx
msgid "Report"
msgstr "Laporan"

#: src/modules/billing/invoice/invoiceLogic.tsx
msgid "Report {id}"
msgstr "Laporan {id}"

#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "Reports"
msgstr "Laporan"

#. Metal commitment status
#: src/modules/metal/statusLabels.tsx
msgid "Requested"
msgstr "Diminta"

#: src/modules/metal/commitment/AddCommitmentModal.tsx
#: src/modules/metal/MetalLeaseDetailView.tsx
msgid "Reservations"
msgstr "Reservasi"

#. Disk status
#: src/modules/disks/DiskList.tsx
#: src/modules/disks/DiskStatusBadge.tsx
msgid "Reserved"
msgstr "Dicadangkan"

#: src/modules/metal/commitment/CommitmentPriceBlock.tsx
msgid "Reserved and prepaid until <0/> ({daysRemaining} days remaining). Price shown as a monthly equivalent."
msgstr "Direservasi dan dibayar di muka hingga <0/> (tersisa {daysRemaining} hari). Harga ditampilkan sebagai setara bulanan."

#: src/modules/user/ProfileView.tsx
msgid "Reset password"
msgstr "Atur ulang kata sandi"

#: src/modules/compute/DiskAddOrResizeModal.tsx
#: src/modules/compute/VmResizeModal.tsx
#: src/modules/compute/VmResizeModal.tsx
#: src/modules/compute/VmResizeModal.tsx
#: src/modules/compute/VmView.tsx
msgid "Resize"
msgstr "Ubah ukuran"

#: src/modules/compute/DiskAddOrResizeModal.tsx
msgid "Resize disk"
msgstr "Ubah ukuran disk"

#: src/modules/compute/VmResizeModal.tsx
msgid "Resizing is only possible when the virtual machine is stopped."
msgstr "Mengubah ukuran hanya dapat dilakukan saat mesin virtual dihentikan."

#: src/modules/billing/statusHistory/statusHistoryLabels.tsx
msgid "Resource allocation is forbidden. Existing resources are deleted."
msgstr ""

#: src/modules/billing/statusHistory/statusHistoryLabels.tsx
msgid "Resource allocation is forbidden. Existing resources are stopped."
msgstr ""

#: src/modules/billing/statusHistory/statusHistoryLabels.tsx
msgid "Resource allocation is limited"
msgstr ""

#: src/modules/compute/VmCloneModal.tsx
#: src/modules/compute/VmCreate.tsx
#: src/modules/disks/disk/DiskCloneModal.tsx
#: src/modules/disks/DiskCreate.tsx
#: src/modules/metal/MetalCreate.tsx
#: src/modules/network/NetworkCreate.tsx
#: src/modules/network/NetworkCreate.tsx
msgid "Resource name"
msgstr "Nama resource"

#: src/modules/network/firewall/FirewallView.tsx
#: src/modules/network/firewall/FirewallView.tsx
#: src/modules/network/vpc/VpcView.tsx
msgid "Resources"
msgstr "Resource"

#. VM is accessible by:
#: src/modules/compute/VmView.tsx
msgid "resources in the same VPC network using private addresses of primary interfaces"
msgstr "resource di jaringan VPC yang sama menggunakan alamat privat dari antarmuka utama"

#. VM is accessible by:
#: src/modules/compute/VmView.tsx
msgid "resources in the VPCs shared by VLAN sub-interfaces using their respective private address"
msgstr "resource di VPC yang dibagikan oleh subinterface VLAN menggunakan alamat privat masing-masing"

#: src/modules/billing/omise/parseOmisePersistentData.ts
msgid "Response seems to be taking longer than expected. Wait a bit and refresh the page to see changes reflected. The result might be either successful or unsuccessful."
msgstr "Respons tampaknya memerlukan waktu lebih lama dari yang diharapkan. Tunggu sebentar lalu muat ulang halaman untuk melihat perubahannya. Hasilnya bisa berhasil atau gagal."

#: src/modules/billing/payment/paymentUtils.ts
msgid "Response seems to be taking more time than expected. Wait a bit and refresh the page to see payment status changes reflected. If it doesn't happen in a reasonable time, please contact support."
msgstr "Respons tampaknya memerlukan waktu lebih lama dari yang diharapkan. Tunggu sebentar dan muat ulang halaman untuk melihat perubahan status pembayaran. Jika tidak terjadi dalam waktu yang wajar, silakan hubungi dukungan."

#: src/modules/compute/VmRestoreFromReplicaModal.tsx
#: src/modules/compute/VmRestoreFromReplicaModal.tsx
#: src/modules/services/Backups.tsx
#: src/modules/services/Backups.tsx
msgid "Restore"
msgstr "Pulihkan"

#: src/modules/compute/VmRestoreFromReplicaModal.tsx
#: src/modules/services/Backups.tsx
msgid "Restore from backup"
msgstr "Pulihkan dari backup"

#: src/modules/compute/VmRestoreFromReplicaModal.tsx
msgid "Restore from snapshot"
msgstr "Pulihkan dari snapshot"

#: src/modules/services/Backups.tsx
msgid "Restoring from a backup will overwrite the service's state with the selected backup's state."
msgstr "Pemulihan dari backup akan menimpa status layanan dengan status dari backup yang dipilih."

#: src/modules/compute/VmRestoreFromReplicaModal.tsx
msgid "Restoring this backup will overwrite the current state."
msgstr "Memulihkan backup ini akan menimpa status saat ini."

#: src/modules/compute/VmRestoreFromReplicaModal.tsx
msgid "Restoring this snapshot will overwrite the current state."
msgstr "Memulihkan snapshot ini akan menimpa status saat ini."

#: src/modules/access/scopeLabel.tsx
msgid "Restricted"
msgstr "Terbatas"

#: src/modules/billing/statusHistory/statusHistoryLabels.tsx
msgid "Restriction level changed"
msgstr ""

#: src/modules/compute/VmView.tsx
msgid "Retention"
msgstr "Periode penyimpanan"

#. Button action
#: src/components/sidebar/ErrorItem.tsx
#: src/modules/notifications/toast.tsx
msgid "Retry"
msgstr "Coba lagi"

#: src/styles/readyidc/theme.tsx
msgid "Revolutionize your cloud with AMD EPYC"
msgstr "Hadirkan perubahan besar pada layanan cloud Anda dengan AMD EPYC"

#. Registre National des Entreprises (RNE) company registration document
#: src/styles/dataxion/theme.tsx
msgid "RNE document"
msgstr "Dokumen RNE"

#: src/modules/network/firewall/firewallLabels.tsx
msgid "Rules from all attached firewalls are combined, a connection is allowed if there is at least one rule that allows it."
msgstr "Aturan dari semua firewall yang dilampirkan digabungkan; koneksi diizinkan jika ada setidaknya satu aturan yang mengizinkannya."

#: src/modules/metal/MetalCreate.tsx
msgid "Run your applications on Bare Metal Servers for full control, security, and raw performance. Provision a dedicated server optimized for your most demanding use cases."
msgstr "Jalankan aplikasi Anda di server bare metal untuk kontrol penuh, keamanan, dan performa maksimal. Sediakan server dedicated yang dioptimalkan untuk kebutuhan penggunaan Anda yang paling menuntut."

#. Virtual machine status
#: src/modules/compute/ChangePasswordModal.tsx
#: src/modules/compute/monitor/MetricChart.tsx
#: src/modules/compute/statusLabels.tsx
#: src/modules/services/ServicesList.tsx
msgid "Running"
msgstr "Berjalan"

#: src/modules/storage/StorageCreate.tsx
msgid "S3-compatible object storage allows you to scale your storage resources up and down without any upfront payments. Create a new storage account, create some buckets and start storing your data in a scalable way - Pay-as-you-grow."
msgstr "Penyimpanan objek yang kompatibel dengan S3 memungkinkan Anda menambah atau mengurangi sumber daya penyimpanan tanpa pembayaran di muka. Buat akun penyimpanan baru, buat beberapa bucket, dan mulai simpan data Anda dengan cara yang skalabel - bayar sesuai pertumbuhan penggunaan."

#: src/modules/billing/AutomatedTopUpModal.tsx
#: src/modules/billing/billingAccount/BillingCreate.tsx
#: src/modules/billing/LowBalanceNotificationsModal.tsx
#: src/modules/currency/CurrencyModal.tsx
#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Save"
msgstr "Simpan"

#: src/modules/billing/progressLabels.tsx
msgid "Saving payment information"
msgstr "Menyimpan informasi pembayaran"

#: src/modules/billing/QrCodeDisplay.tsx
msgid "Scan the QR code to pay"
msgstr "Pindai kode QR untuk membayar"

#: src/modules/access/AccessCreate.tsx
#: src/modules/user/ProfileView.tsx
msgid "Scope"
msgstr "Cakupan"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Search"
msgstr "Cari"

#: src/modules/storage/account/StorageAccountView.tsx
#: src/modules/storage/account/StorageAccountView.tsx
msgid "Secret access key"
msgstr "Kunci akses rahasia"

#: src/modules/billing/forms/FileWithSourceInput.tsx
msgid "Select a file"
msgstr "Pilih file"

#: src/modules/billing/billingAccount/BillingCreate.tsx
#: src/modules/billing/payment/PaymentModal.tsx
msgid "Select a payment method"
msgstr "Pilih metode pembayaran"

#: src/components/forms/WSelect.tsx
msgid "Select an option"
msgstr "Pilih opsi"

#. placeholder {0}: siteCurrencyInfo.title
#: src/modules/currency/CurrencyModal.tsx
msgid "Select your display currency to view prices in your preferred currency. Displayed amounts and exchange rates are indicative and for informational purposes only. All transactions are processed in the underlying currency ({0}), and final charges may vary based on your payment provider's rates."
msgstr "Pilih mata uang tampilan untuk melihat harga dalam mata uang pilihan Anda. Jumlah yang ditampilkan dan nilai tukar hanya bersifat indikatif dan untuk tujuan informasi. Semua transaksi diproses dalam mata uang dasar ({0}), dan tagihan akhir dapat berbeda tergantung pada kurs dari penyedia pembayaran Anda."

#: src/modules/currency/CurrencyModal.tsx
msgid "Select your preferred currency"
msgstr "Pilih mata uang pilihan Anda"

#: src/modules/compute/WVnc.tsx
msgid "Send Ctrl+Alt+Del"
msgstr "Kirim Ctrl+Alt+Del"

#: src/modules/login/Login.tsx
msgid "Send email"
msgstr "Kirim email"

#: src/modules/storage/account/StorageAccountView.tsx
#: src/modules/storage/bucket/BucketView.tsx
msgid "Server"
msgstr "Server"

#: src/modules/compute/VmCreate.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/disks/DiskCreate.tsx
#: src/modules/metal/MetalCreate.tsx
#: src/modules/metal/MetalLeaseDetailView.tsx
#: src/modules/pricing/PricingModal.tsx
msgid "Server class"
msgstr "Kelas server"

#: src/modules/billing/invoice/InvoiceView.tsx
#: src/modules/services/ServiceCreate.tsx
#: src/modules/services/ServiceView.tsx
msgid "Service"
msgstr "Layanan"

#: src/modules/services/ServiceCreate.tsx
msgid "Service name"
msgstr "Nama layanan"

#: src/modules/api/resourceTypes.tsx
#: src/modules/billing/invoice/InvoiceView.tsx
#: src/modules/main/sidebar/Sidebar.sections.tsx
#: src/modules/services/ServicesList.tsx
msgid "Services"
msgstr "Layanan"

#: src/modules/billing/statusHistory/StatusHistory.tsx
msgid "Set by an administrator"
msgstr ""

#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/network/vpc/VpcView.tsx
msgid "Set default"
msgstr "Tetapkan sebagai default"

#. 'private' is a literal string
#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Set object's ACL to 'private'"
msgstr "Atur ACL objek ke 'private'"

#. 'public-read' is a literal string
#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Set object's ACL to 'public-read'"
msgstr "Atur ACL objek ke 'public-read'"

#. Button action
#: src/modules/dashboard/UserAccess.tsx
#: src/modules/dashboard/UserAccess.tsx
msgid "Share access"
msgstr "Bagikan akses"

#: src/modules/billing/referral/ReferralProgram.tsx
msgid "Share on Facebook"
msgstr "Bagikan di Facebook"

#: src/modules/billing/referral/ReferralProgram.tsx
msgid "Share on LinkedIn"
msgstr "Bagikan di LinkedIn"

#. X is the social network
#: src/modules/billing/referral/ReferralProgram.tsx
msgid "Share on X"
msgstr "Bagikan di X"

#: src/modules/storage/s3/S3FileBrowser.tsx
#: src/modules/storage/s3/S3FileBrowser.tsx
#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Share temporarily"
msgstr "Bagikan sementara"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Sharing duration"
msgstr "Durasi berbagi"

#. Button action
#: src/components/SecretKey.tsx
#: src/modules/services/TextSecret.tsx
msgid "Show"
msgstr "Tampilkan"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Show details"
msgstr "Tampilkan detail"

#. An item is any kind of resource being managed (e.g. VM, disk, bucket, etc).
#: src/modules/dashboard/RecentlyModified.tsx
msgid "Showing {limit} latest items"
msgstr "Menampilkan {limit} item terbaru"

#: src/modules/billing/BillingDiscountNotice.tsx
msgid "Showing list prices. Discount applied in the cost summary."
msgstr "Menampilkan harga daftar. Diskon diterapkan dalam ringkasan biaya."

#: src/modules/login/auth0/Auth0Login.tsx
#: src/modules/login/Login.tsx
msgid "Sign up"
msgstr "Daftar"

#: src/modules/login/Login.tsx
msgid "Sign up with Google"
msgstr "Daftar dengan Google"

#: src/modules/compute/DiskAddOrResizeModal.tsx
#: src/modules/compute/VmCreate.tsx
#: src/modules/compute/VmResizeModal.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/disks/disk/DiskView.tsx
#: src/modules/disks/DiskCreate.tsx
#: src/modules/disks/DiskList.tsx
#: src/modules/services/Backups.tsx
#: src/modules/services/kubernetes/NodeResizeModal.tsx
#: src/modules/services/ServiceCreate.tsx
#: src/modules/services/ServiceView.tsx
#: src/modules/storage/account/StorageAccountView.tsx
#: src/modules/storage/account/StorageAccountView.tsx
#: src/modules/storage/bucket/BucketView.tsx
#: src/modules/storage/StorageList.tsx
msgid "Size"
msgstr "Ukuran"

#: src/modules/compute/VmView.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/disks/disk/DiskView.tsx
msgid "Size (GB)"
msgstr "Ukuran (GB)"

#: src/modules/compute/VmView.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/disks/disk/DiskView.tsx
#: src/modules/disks/disk/DiskView.tsx
msgid "Snapshots"
msgstr "Snapshot"

#: src/modules/billing/referral/ReferralProgram.tsx
msgid "Social share"
msgstr "Bagikan ke media sosial"

#: src/modules/metal/spec/SpecRadio.tsx
msgid "Sold out"
msgstr "Habis"

#. Label for dropdown menu that selects by what files are sorted. | POS: Verb
#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Sort"
msgstr "Urutkan"

#: src/components/sidebar/SortMenu.tsx
msgid "Sort by"
msgstr "Urutkan berdasarkan"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Sort by date"
msgstr "Urutkan berdasarkan tanggal"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Sort by name"
msgstr "Urutkan berdasarkan nama"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Sort by size"
msgstr "Urutkan berdasarkan ukuran"

#: src/modules/network/loadbalancer/ForwardingRulesList.tsx
msgid "Source port"
msgstr "Port sumber"

#: src/modules/network/loadbalancer/validatePorts.ts
msgid "Source port must be unique"
msgstr "Port sumber harus unik"

#: src/modules/compute/VmView.tsx
#: src/modules/network/firewall/EditRuleModal.tsx
#: src/modules/network/firewall/FirewallView.tsx
#: src/modules/network/firewall/RulesList.tsx
msgid "Sources"
msgstr "Sumber"

#: src/modules/compute/AddSshKeyModal.tsx
msgid "SSH key does not match required pattern"
msgstr "Kunci SSH tidak sesuai dengan format yang diperlukan"

#: src/modules/compute/VmCreate.tsx
#: src/modules/user/ProfileView.tsx
msgid "SSH keys"
msgstr "Kunci SSH"

#: src/modules/compute/VmCreate.tsx
msgid "SSH keys can be managed under your <0>user profile</0>."
msgstr "Kunci SSH dapat dikelola di <0>profil pengguna</0> Anda."

#: src/modules/compute/VmToolbar.tsx
msgid "SSH link"
msgstr "Tautan SSH"

#: src/modules/compute/VmRootUserWarning.tsx
msgid "SSH might not be available for root user due to operating system initial setup. Please use virtual console to access the system and make the SSH server config changes according to your needs."
msgstr "SSH mungkin tidak tersedia untuk pengguna root karena pengaturan awal sistem operasi. Silakan gunakan konsol virtual untuk mengakses sistem dan ubah konfigurasi server SSH sesuai kebutuhan Anda."

#. Button action
#: src/modules/compute/BootFromIsoModal.tsx
#: src/modules/compute/ChangePasswordModal.tsx
#: src/modules/compute/VmToolbar.tsx
#: src/modules/services/ServiceView.tsx
#: src/modules/support/WChatProvider.tsx
#: src/modules/user/ActAsModal.tsx
msgid "Start"
msgstr "Mulai"

#: src/modules/metal/MetalLeaseDetailView.tsx
msgid "Start date"
msgstr "Tanggal mulai"

#: src/modules/billing/account_validation/digio/StartDigioValidationButton.tsx
msgid "Start here"
msgstr "Mulai di sini"

#: src/modules/network/NetworkCreate.tsx
msgid "Start managing your networks by creating a new network resource."
msgstr "Mulai kelola jaringan Anda dengan membuat sumber daya jaringan baru."

#: src/modules/network/firewall/firewallLabels.tsx
msgid "Start port"
msgstr "Port awal"

#: src/modules/network/firewall/validatePorts.ts
msgid "Start port must be unique"
msgstr "Port awal harus unik"

#: src/modules/dashboard/StartSomethingNew.tsx
msgid "Start something new"
msgstr "Mulai sesuatu yang baru"

#: src/modules/services/kubernetes/Maintenance.tsx
#: src/modules/services/kubernetes/MaintenanceEditModal.tsx
msgid "Start time"
msgstr "Waktu mulai"

#: src/modules/billing/progressLabels.tsx
msgid "Starting payment"
msgstr "Memulai pembayaran"

#. Part of address
#: src/modules/billing/billingAccount/fieldsInfo.tsx
msgid "State"
msgstr "Provinsi"

#: src/modules/access/delegation/DelegationView.tsx
#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/invoice/InvoiceView.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/disks/disk/DiskView.tsx
#: src/modules/metal/MetalLeaseDetailView.tsx
#: src/modules/metal/MetalLeaseDetailView.tsx
#: src/modules/network/firewall/AssignedToList.tsx
#: src/modules/network/firewall/FirewallView.tsx
#: src/modules/network/ipAddress/IpAddressView.tsx
#: src/modules/network/loadbalancer/LoadBalancerView.tsx
#: src/modules/network/loadbalancer/TargetServersList.tsx
#: src/modules/network/vpc/VpcView.tsx
#: src/modules/services/ServiceView.tsx
#: src/modules/user/ProfileView.tsx
msgid "Status"
msgstr "Status"

#. Short of: billing account status history
#: src/modules/billing/statusHistory/statusHistoryLabels.tsx
msgid "Status history"
msgstr ""

#: src/modules/compute/ModalHeaderBlock.tsx
#: src/modules/compute/VmToolbar.tsx
#: src/modules/compute/VmToolbar.tsx
#: src/modules/compute/VmToolbar.tsx
#: src/modules/services/ServiceView.tsx
#: src/modules/services/ServiceView.tsx
#: src/modules/services/ServiceView.tsx
msgid "Stop"
msgstr "Hentikan"

#. Virtual machine status
#: src/modules/compute/ModalHeaderBlock.tsx
#: src/modules/compute/statusLabels.tsx
#: src/modules/services/ServicesList.tsx
msgid "Stopped"
msgstr "Dihentikan"

#. Virtual machine status
#: src/modules/compute/statusLabels.tsx
msgid "Stopping"
msgstr "Menghentikan"

#: src/modules/api/resourceTypes.tsx
#: src/modules/main/sidebar/Sidebar.sections.tsx
#: src/modules/storage/StorageList.tsx
msgid "Storage"
msgstr "Penyimpanan"

#: src/modules/storage/account/StorageAccountView.tsx
msgid "Storage access keys"
msgstr "Kunci akses penyimpanan"

#: src/modules/api/resourceTypes.tsx
#: src/modules/storage/bucket/BucketView.tsx
msgid "Storage account"
msgstr "Akun penyimpanan"

#: src/modules/api/resourceTypes.tsx
msgid "Storage bucket"
msgstr "Bucket penyimpanan"

#: src/modules/storage/account/CreateBucketModal.tsx
msgid "Storage bucket name"
msgstr "Nama bucket penyimpanan"

#. List of S3 storage buckets
#: src/modules/storage/account/StorageAccountView.tsx
msgid "Storage buckets"
msgstr "Bucket penyimpanan"

#: src/modules/billing/billingAccount/fieldsInfo.tsx
msgid "Street address"
msgstr "Alamat jalan"

#: src/modules/services/ConnectionDetails.tsx
msgid "String"
msgstr "String"

#: src/modules/network/NetworkCreate.tsx
msgid "Subnet range (CIDR)"
msgstr "Rentang subnet (CIDR)"

#: src/modules/billing/invoice/InvoiceView.tsx
msgid "Subtotal"
msgstr "Subtotal"

#: src/modules/billing/invoice/InvoiceView.tsx
msgid "Subtotal before discounts"
msgstr ""

#. Button label. Short of: Contact customer support
#: src/modules/main/TopNav.tsx
msgid "Support"
msgstr "Dukungan"

#. Billing account status
#: src/modules/billing/statusHistory/statusHistoryLabels.tsx
#: src/modules/dashboard/BillingAccounts.tsx
msgid "Suspended"
msgstr "Ditangguhkan"

#: src/modules/billing/statusHistory/statusHistoryLabels.tsx
msgid "Suspension reason changed"
msgstr ""

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Switch to Grid view"
msgstr "Beralih ke tampilan Grid"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Switch to List view"
msgstr "Beralih ke tampilan Daftar"

#: src/modules/services/kubernetes/KubernetesReadynessBadge.tsx
msgid "system"
msgstr "sistem"

#. What caused the billing account status change
#. Who changed the billing account status
#: src/modules/billing/statusHistory/statusHistoryLabels.tsx
#: src/modules/billing/statusHistory/statusHistoryLabels.tsx
msgid "System"
msgstr ""

#: src/modules/compute/labels.tsx
msgid "Take a snapshot to create an instant image of your virtual machine's current state. You can later use the snapshot to restore your virtual machine state or create a new virtual machine from the snapshot with modified size parameters."
msgstr "Ambil snapshot untuk membuat image instan dari status terkini mesin virtual Anda. Anda nantinya dapat menggunakan snapshot tersebut untuk memulihkan status mesin virtual Anda atau membuat mesin virtual baru dari snapshot dengan parameter ukuran yang diubah."

#: src/modules/compute/VmView.tsx
msgid "Take snapshot"
msgstr "Ambil snapshot"

#: src/modules/dashboard/RecentlyModified.tsx
msgid "Take some action and you'll never see this cactus again."
msgstr "Lakukan sesuatu dan Anda tidak akan melihat kaktus ini lagi."

#: src/modules/network/loadbalancer/ForwardingRulesList.tsx
#: src/modules/network/loadbalancer/ForwardingRulesList.tsx
#: src/modules/network/loadbalancer/LoadBalancerView.tsx
msgid "Target port"
msgstr "Port target"

#: src/modules/network/loadbalancer/LoadBalancerView.tsx
#: src/modules/network/loadbalancer/LoadBalancerView.tsx
#: src/modules/network/NetworkCreate.tsx
msgid "Target servers"
msgstr "Server target"

#: src/modules/compute/VmToolbar.tsx
#: src/modules/compute/WVnc.tsx
msgid "Terminal"
msgstr "Konsol"

#. Billing account restriction level
#: src/modules/billing/statusHistory/statusHistoryLabels.tsx
msgid "Terminated"
msgstr ""

#: src/modules/login/ConsentForm.tsx
msgid "Terms of Service"
msgstr "Syarat dan Ketentuan Layanan"

#: src/modules/pricing/PricingModal.tsx
msgid "The actual cost of your resource is calculated based on the below prices and your actual hourly usage. All prices are per one unit of resource (1 vCPU or 1 GiB). Prices do not contain taxes."
msgstr "Biaya aktual sumber daya Anda dihitung berdasarkan harga di bawah ini dan penggunaan aktual Anda per jam. Semua harga berlaku untuk satu unit sumber daya (1 vCPU atau 1 GiB). Harga belum termasuk pajak."

#: src/modules/billing/forms/BillingSelect.tsx
msgid "The billing account has been closed and is no longer available."
msgstr "Akun penagihan telah ditutup dan tidak lagi tersedia."

#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "The campaign code is activated only after a successful top up."
msgstr "Kode kampanye hanya diaktifkan setelah isi saldo berhasil."

#: src/modules/user/ActAsModal.tsx
msgid "The entire user interface will switch and act as you were that user. Once you are finished you can stop the session by clicking “Back to your account” button on the header bar and the user interface will switch back to your account."
msgstr "Seluruh antarmuka pengguna akan beralih dan bertindak seolah-olah Anda adalah pengguna tersebut. Setelah selesai, Anda dapat menghentikan sesi dengan mengeklik tombol “Kembali ke akun Anda” pada bilah header, lalu antarmuka pengguna akan beralih kembali ke akun Anda."

#: src/modules/billing/ConversionMessage.tsx
msgid "The final exchange rate and charge amount will be determined at the moment of actual payment."
msgstr "Nilai tukar final dan jumlah tagihan akan ditentukan pada saat pembayaran dilakukan."

#: src/modules/billing/promotionNotices.tsx
msgid "The first top up will unlock your complimentary free credit of <0><1/></0>."
msgstr "Isi saldo pertama akan membuka kredit gratis sebesar <0><1/></0> untuk Anda."

#: src/modules/billing/omise/OmiseCardAddForm.tsx
msgid "The format is MM/YY"
msgstr "Formatnya adalah BB/TT"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "The link expires on:"
msgstr "Tautan kedaluwarsa pada:"

#: src/modules/storage/account/CreateBucketModal.tsx
msgid "The name can only contain lowercase alphanumeric characters and dashes, it must start with a lowercase letter or number, the allowed length is 3–63."
msgstr "Nama hanya boleh berisi karakter alfanumerik huruf kecil dan tanda hubung, harus diawali dengan huruf kecil atau angka, dan panjang yang diizinkan adalah 3–63 karakter."

#: src/modules/compute/ChangePasswordModal.tsx
msgid "The password can be changed for any existing user account."
msgstr "Kata sandi dapat diubah untuk akun pengguna yang sudah ada."

#: src/modules/billing/sslcommerz/SslcommerzPaymentForm.tsx
msgid "The phone/mobile number to contact if any issue arises"
msgstr "Nomor telepon/ponsel yang dapat dihubungi jika terjadi masalah"

#: src/components/forms/MonthlyCostField.tsx
msgid "The price is approximate, the cost of your resource will be calculated based on your actual hourly usage."
msgstr "Harga ini merupakan perkiraan, biaya resource Anda akan dihitung berdasarkan penggunaan aktual per jam."

#: src/modules/compute/PasswordFields.tsx
msgid "The re-typed password, to ensure that it has been entered correctly."
msgstr "Kata sandi yang diketik ulang untuk memastikan bahwa kata sandi telah dimasukkan dengan benar."

#: src/modules/metal/offer/MetalOfferSection.tsx
msgid "The selected billing account does not have enough credit to purchase this reservation."
msgstr "Akun penagihan yang dipilih tidak memiliki saldo yang cukup untuk membeli reservasi ini."

#: src/modules/metal/offer/MetalOfferSection.tsx
msgid "The selected billing account is limited and can not create reservations."
msgstr "Akun penagihan yang dipilih terbatas dan tidak dapat membuat reservasi."

#: src/modules/network/NetworkCreate.tsx
msgid "The subnet must fall within one the following IP blocks:"
msgstr "Subnet harus berada dalam salah satu blok IP berikut:"

#: src/modules/compute/ChangePasswordModal.tsx
msgid "The user account for which password will be set."
msgstr "Akun pengguna yang kata sandinya akan diatur."

#: src/modules/login/Login.tsx
msgid "There was an error verifying your email address."
msgstr "Terjadi kesalahan saat memverifikasi alamat email Anda."

#: src/components/sidebar/ErrorItem.tsx
msgid "There was an error while creating your resource."
msgstr "Terjadi kesalahan saat membuat resource Anda."

#: src/modules/metal/MetalLeaseDetailView.tsx
msgid "These credentials are only for the initial login. It is recommended to change these immediately."
msgstr "Kredensial ini hanya untuk login awal. Disarankan untuk segera mengubahnya."

#. This resource was not found
#: src/modules/error/ErrorFallback.tsx
msgid "This {resourceTypeName} is gone"
msgstr "{resourceTypeName} ini sudah tidak ada"

#: src/modules/metal/MetalLeaseDetailView.tsx
msgid "This bare metal server is still being set up."
msgstr "Server bare metal ini masih dalam proses penyiapan."

#: src/modules/billing/LimitedBillingAccountNotice.tsx
msgid "This billing account has limited capabilities when creating resources."
msgstr "Akun penagihan ini memiliki kemampuan terbatas saat membuat resource."

#: src/modules/dashboard/BillingAccounts.tsx
msgid "This billing account is limited"
msgstr "Akun penagihan ini terbatas"

#: src/modules/compute/VmCreate.tsx
msgid "This distribution adds a <0/> cost per hour for licensing (<1/> per month)."
msgstr "Distribusi ini menambahkan biaya <0/> per jam untuk lisensi (<1/> per bulan)."

#: src/components/forms/requiredMessage.tsx
msgid "This field is required"
msgstr "Kolom ini wajib diisi"

#: src/modules/storage/account/CreateKeyModal.tsx
msgid "This key has access to all buckets under this storage account. To restrict access to specific buckets, create a separate storage account."
msgstr "Kunci ini memiliki akses ke semua bucket di bawah akun penyimpanan ini. Untuk membatasi akses ke bucket tertentu, buat akun penyimpanan terpisah."

#. This page was not found
#: src/modules/error/ErrorFallback.tsx
msgid "This page is gone"
msgstr "Halaman ini sudah tidak ada"

#: src/modules/services/Access.tsx
#: src/modules/services/Networking.tsx
msgid "This service is accessible only by resources in the same VPC network using these private addresses."
msgstr "Layanan ini hanya dapat diakses oleh resource dalam jaringan VPC yang sama menggunakan alamat privat ini."

#: src/modules/compute/VmView.tsx
msgid "This virtual machine is accessible by:"
msgstr "Mesin virtual ini dapat diakses oleh:"

#: src/modules/network/firewall/FirewallDeleteModal.tsx
msgid "This will delete the firewall and its associated rules, and they will no longer apply to any assigned resources."
msgstr "Ini akan menghapus firewall beserta aturan terkaitnya, dan aturan tersebut tidak akan lagi berlaku untuk resource yang ditetapkan."

#: src/modules/compute/VmToolbar.tsx
msgid "This will forcefully shut down your resource \"{name}\". For stopped resources you will only be charged for the storage."
msgstr "Ini akan mematikan resource \"{name}\" Anda secara paksa. Untuk resource yang dihentikan, Anda hanya akan dikenai biaya penyimpanan."

#: src/modules/services/ServiceView.tsx
msgid "This will hibernate cluster \"{display_name}\"."
msgstr "Ini akan menghibernasikan cluster \"{display_name}\"."

#: src/modules/billing/billingAccount/BillingCreate.tsx
#: src/modules/storage/StorageCreate.tsx
msgid "This will only be used within the system so it's easy for you to recognize the account if you have several."
msgstr "Ini hanya akan digunakan di dalam sistem agar Anda mudah mengenali akun tersebut jika Anda memiliki beberapa akun."

#: src/modules/compute/VmToolbar.tsx
msgid "This will reboot your resource \"{name}\"."
msgstr "Ini akan memulai ulang resource \"{name}\" Anda."

#: src/modules/services/IpWhitelist.tsx
msgid "This will remove the address or range from the allowlist.<0/>Note that an empty allowlist will permit connections from any address."
msgstr "Ini akan menghapus alamat atau rentang dari daftar IP yang diizinkan.<0/>Perlu diketahui bahwa daftar IP yang diizinkan yang kosong akan mengizinkan koneksi dari alamat mana pun."

#: src/modules/services/ServiceView.tsx
msgid "This will shut down your resource \"{display_name}\". If graceful shutdown does not finish in 120 seconds, then a forceful stop will be carried out. For stopped resources you will only be charged for the storage."
msgstr "Ini akan mematikan resource Anda \"{display_name}\". Jika graceful shutdown tidak selesai dalam 120 detik, penghentian paksa akan dilakukan. Untuk resource yang dihentikan, Anda hanya akan dikenakan biaya penyimpanan."

#: src/modules/compute/VmToolbar.tsx
msgid "This will shut down your resource \"{name}\". If graceful shutdown does not finish in 120 seconds, then a forceful stop will be carried out. For stopped resources you will only be charged for the storage."
msgstr "Ini akan mematikan resource \"{name}\" Anda. Jika penghentian normal tidak selesai dalam 120 detik, penghentian paksa akan dilakukan. Untuk resource yang dihentikan, Anda hanya akan dikenai biaya penyimpanan."

#: src/modules/network/loadbalancer/LoadBalancerDeleteModal.tsx
msgid "This will stop forwarding traffic to the targets and remove the load balancer."
msgstr "Ini akan menghentikan penerusan lalu lintas ke target dan menghapus load balancer."

#. Amount below which a low balance notification will be sent
#: src/modules/billing/LowBalanceNotificationsModal.tsx
msgid "Threshold"
msgstr "Ambang batas"

#. This page was not found
#: src/modules/error/ErrorFallback.tsx
msgid "Time to move on. Here are some ideas where to go next:"
msgstr "Saatnya beralih. Berikut beberapa pilihan tujuan berikutnya:"

#: src/modules/error/ErrorFallback.tsx
msgid "Time to move on. This item is deleted or you do not have access."
msgstr "Saatnya beralih. Item ini telah dihapus atau Anda tidak memiliki akses."

#: src/modules/billing/razorpay/RazorpayPaymentForm.tsx
msgid "Timed out waiting for a response from Razorpay"
msgstr "Waktu tunggu respons dari Razorpay habis"

#: src/modules/services/kubernetes/Maintenance.tsx
#: src/modules/services/kubernetes/MaintenanceEditModal.tsx
msgid "Timezone"
msgstr "Zona waktu"

#: src/modules/billing/BillingAccountNotices.tsx
msgid "To activate a billing account, please add a credit card as a payment method or contact support to enable invoice payments."
msgstr "Untuk mengaktifkan akun penagihan, silakan tambahkan kartu kredit sebagai metode pembayaran atau hubungi dukungan untuk mengaktifkan pembayaran faktur."

#: src/modules/services/IpWhitelist.tsx
msgid "To restrict connections to the service you have to add at least one inbound IP to the allowlist (All other public and private connections will be denied). You can specify a single IPv4 address or a block of addresses using CIDR notation (e.g. 1.1.1.0/24)"
msgstr "Untuk membatasi koneksi ke layanan, Anda harus menambahkan setidaknya satu IP masuk ke daftar IP yang diizinkan (semua koneksi publik dan privat lainnya akan ditolak). Anda dapat menentukan satu alamat IPv4 atau sekumpulan alamat menggunakan notasi CIDR (misalnya 1.1.1.0/24)"

#: src/modules/billing/BillingAccountNotices.tsx
#: src/modules/dashboard/WelcomeModal.tsx
msgid "To start using the platform you need to first setup billing account. You are welcome to click around to familiarize yourself with the system and come back to billing account creation at any time you are ready to start building your first resources."
msgstr "Untuk mulai menggunakan platform, Anda harus terlebih dahulu menyiapkan akun penagihan. Silakan menjelajahi sistem untuk membiasakan diri, lalu kembali membuat akun penagihan kapan saja saat Anda siap mulai membuat sumber daya pertama Anda."

#: src/modules/login/ConsentForm.tsx
msgid "To use our services, you need to agree to the Terms of Service."
msgstr "Untuk menggunakan layanan kami, Anda perlu menyetujui Syarat dan Ketentuan Layanan."

#: src/modules/access/token/TokenView.tsx
msgid "Token"
msgstr "Token"

#: src/modules/billing/payment/PaymentModal.tsx
msgid "Top up"
msgstr "Isi saldo"

#. How much to top up | POS: Noun
#: src/modules/billing/CurrencyPaymentFees.tsx
msgid "Top up amount"
msgstr "Jumlah isi saldo"

#: src/modules/billing/promotionNotices.tsx
msgid "Top up at least <0><1/></0> to obtain <2><3/></2> of referral code bonus."
msgstr "Isi saldo minimal <0><1/></0> untuk mendapatkan bonus kode referral sebesar <2><3/></2>."

#: src/modules/billing/ActionButtons.tsx
msgid "Top up now"
msgstr "Isi saldo sekarang"

#. Top up your billing account
#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/BillingAccountInfo.tsx
#: src/modules/billing/payment/PaymentModal.tsx
msgid "Top up your account"
msgstr "Isi saldo akun Anda"

#. What caused the billing account status change
#: src/modules/billing/statusHistory/statusHistoryLabels.tsx
msgid "Top-up"
msgstr ""

#. Invoices for billing account top-ups
#: src/components/themeTrans.tsx
msgid "Top-up invoices"
msgstr "Faktur isi saldo"

#: src/styles/dataxion/theme.tsx
msgid "Top-up orders"
msgstr "Pesanan isi saldo"

#: src/modules/billing/statusHistory/StatusHistory.tsx
msgid "Top-up threshold reached"
msgstr ""

#: src/modules/billing/statusHistory/StatusHistory.tsx
msgid "Top-ups of <0/> are below the threshold of <1/>"
msgstr ""

#: src/modules/billing/statusHistory/StatusHistory.tsx
msgid "Top-ups of <0/> reached the threshold of <1/>"
msgstr ""

#. Total amount of the invoice
#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/invoice/InvoiceView.tsx
#: src/modules/billing/InvoicePaymentInfo.tsx
msgid "Total"
msgstr "Total"

#: src/modules/billing/CurrencyPaymentFees.tsx
msgid "Total charge"
msgstr "Total tagihan"

#. Short of: Total excluding
#: src/modules/billing/invoice/InvoiceView.tsx
msgid "Total excl. {vatSymbol}"
msgstr "Total tidak termasuk {vatSymbol}"

#: src/components/themeTrans.tsx
msgid "Total of all unpaid invoices. Including {vatSymbol}."
msgstr "Total semua faktur yang belum dibayar. Termasuk {vatSymbol}."

#: src/styles/dataxion/theme.tsx
msgid "Total of all unpaid orders. Including VAT."
msgstr "Total semua pesanan yang belum dibayar. Termasuk PPN."

#: src/modules/billing/CurrencyPaymentFees.tsx
#: src/modules/billing/CurrencyPaymentFees.tsx
msgid "Transaction fee"
msgstr "Biaya transaksi"

#. Table column: what caused the change | POS: Noun
#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "Trigger"
msgstr ""

#: src/modules/access/AccessCreate.tsx
#: src/modules/access/AccessList.tsx
#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/compute/ReinstallModal.tsx
#: src/modules/compute/VmCreate.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/disks/disk/DiskView.tsx
#: src/modules/metal/MetalCreate.tsx
#: src/modules/metal/MetalLeaseDetailView.tsx
#: src/modules/network/firewall/AssignedToList.tsx
#: src/modules/network/firewall/EditRuleModal.tsx
#: src/modules/network/firewall/FirewallView.tsx
#: src/modules/network/firewall/FirewallView.tsx
#: src/modules/network/firewall/FirewallView.tsx
#: src/modules/network/firewall/RulesList.tsx
#: src/modules/network/ipAddress/IpAddressView.tsx
#: src/modules/network/loadbalancer/LoadBalancerView.tsx
#: src/modules/network/loadbalancer/LoadBalancerView.tsx
#: src/modules/network/loadbalancer/TargetServersList.tsx
#: src/modules/network/NetworkCreate.tsx
#: src/modules/network/NetworkList.tsx
#: src/modules/network/vpc/VpcView.tsx
#: src/modules/network/vpc/VpcView.tsx
#: src/modules/services/ServiceView.tsx
#: src/modules/storage/account/StorageAccountView.tsx
#: src/modules/storage/bucket/BucketView.tsx
#: src/modules/storage/StorageCreate.tsx
msgid "Type"
msgstr "Jenis"

#: src/modules/compute/labels.tsx
msgid "UEFI variables (NVRAM) will not persist across reboots."
msgstr "Variabel UEFI (NVRAM) tidak akan tersimpan setelah reboot."

#: src/modules/access/AccessList.tsx
msgid "UI"
msgstr "UI"

#: src/modules/network/ipAddress/IpAddressView.tsx
#: src/modules/network/ipAddress/IpAddressView.tsx
#: src/modules/network/ipAddress/UnAssignButton.tsx
msgid "Unassign"
msgstr "Batalkan penetapan"

#. State of IP address
#: src/modules/dashboard/RecentlyModified.tsx
#: src/modules/network/CreateAndAssignIpField.tsx
#: src/modules/network/ipAddress/IpAddressView.tsx
#: src/modules/network/NetworkList.tsx
#: src/modules/network/UnassignedItem.tsx
msgid "Unassigned"
msgstr "Belum ditetapkan"

#: src/modules/billing/invoice/InvoiceView.tsx
msgid "Unit"
msgstr "Unit"

#. Label for an unknown item in a select control
#: src/components/EnumBadge.tsx
#: src/modules/billing/BillingAccountLink.tsx
#: src/modules/network/NetworkList.tsx
msgid "Unknown"
msgstr "Tidak diketahui"

#: src/modules/login/auth0/Auth0Exception.ts
msgid "Unknown Auth0 error"
msgstr "Kesalahan Auth0 tidak diketahui"

#: src/modules/access/scopeLabel.tsx
msgid "Unknown billing account"
msgstr "Akun penagihan tidak diketahui"

#: src/modules/billing/payment/paymentUtils.ts
msgid "Unknown payment error{codeSuffix}"
msgstr "Kesalahan pembayaran tidak diketahui{codeSuffix}"

#: src/modules/disks/AttachedToSelect.tsx
#: src/modules/network/AssignToSelect.tsx
msgid "Unknown resource"
msgstr "Sumber daya tidak diketahui"

#: src/modules/network/loadbalancer/LoadBalancerView.tsx
msgid "Unlink target"
msgstr "Lepas target"

#: src/modules/billing/BillingList.tsx
#: src/modules/billing/ReportStatus.tsx
#: src/modules/dashboard/BillingAccounts.tsx
msgid "Unpaid"
msgstr "Belum dibayar"

#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "Unpaid amount"
msgstr "Jumlah belum dibayar"

#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/payment/PaymentModal.tsx
msgid "Unverified"
msgstr "Belum diverifikasi"

#: src/modules/compute/UpdateSshKeyModal.tsx
msgid "Update"
msgstr "Perbarui"

#: src/modules/compute/UpdateSshKeyModal.tsx
msgid "Update SSH key"
msgstr "Perbarui kunci SSH"

#. Button action to upload a file. | POS: Verb
#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Upload"
msgstr "Unggah"

#: src/styles/dataxion/theme.tsx
msgid "Upload a copy of only the RNE document for verification"
msgstr "Unggah salinan dokumen RNE saja untuk verifikasi"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Uploading files"
msgstr "Mengunggah file"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Uploads are still in progress. If you leave this page, progress will no longer be shown and uploads may be interrupted. Leave anyway?"
msgstr "Unggahan masih berlangsung. Jika Anda meninggalkan halaman ini, progres tidak akan lagi ditampilkan dan unggahan mungkin terganggu. Tetap tinggalkan halaman?"

#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "Usage"
msgstr "Penggunaan"

#. What caused the billing account status change
#: src/modules/billing/statusHistory/statusHistoryLabels.tsx
msgid "Usage charge"
msgstr ""

#: src/modules/compute/VmCreate.tsx
msgid "Use the ISO boot option after the virtual machine has been created to install an operating system yourself."
msgstr "Gunakan opsi boot dari ISO setelah mesin virtual dibuat untuk menginstal sistem operasi sendiri."

#. Who changed the billing account status
#: src/modules/billing/statusHistory/statusHistoryLabels.tsx
msgid "User"
msgstr ""

#: src/modules/dashboard/UserAccess.tsx
msgid "User access"
msgstr "Mengakses"

#: src/modules/access/delegation/DelegationView.tsx
#: src/modules/dashboard/UserAccess.tsx
msgid "User must accept access invitation from their profile view"
msgstr "Pengguna harus menerima undangan akses dari tampilan profil mereka"

#. Link to regular user interface
#: src/modules/user/UserMenu.tsx
msgid "User view"
msgstr "Tampilan pengguna"

#: src/modules/access/delegation/AddImpersonationForm.tsx
msgid "User's email"
msgstr "Email pengguna"

#: src/modules/compute/ChangePasswordModal.tsx
#: src/modules/compute/VmCreate.tsx
#: src/modules/compute/VmCreate.tsx
#: src/modules/compute/VmView.tsx
msgid "Username"
msgstr "Nama pengguna"

#: src/modules/dashboard/UserAccess.tsx
#: src/modules/user/ProfileView.tsx
msgid "Users I can access"
msgstr "Pengguna yang dapat saya akses"

#: src/modules/access/delegation/DelegationView.tsx
#: src/modules/dashboard/UserAccess.tsx
#: src/modules/user/ProfileView.tsx
msgid "Users who can access my account"
msgstr "Pengguna yang dapat mengakses akun saya"

#: src/modules/compute/VmView.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/disks/disk/DiskView.tsx
#: src/modules/disks/disk/DiskView.tsx
#: src/modules/metal/MetalLeaseDetailView.tsx
#: src/modules/metal/MetalLeaseDetailView.tsx
#: src/modules/network/firewall/FirewallView.tsx
#: src/modules/network/loadbalancer/LoadBalancerView.tsx
#: src/modules/network/vpc/VpcView.tsx
#: src/modules/services/Backups.tsx
#: src/modules/services/ServiceView.tsx
#: src/modules/storage/account/StorageAccountView.tsx
msgid "UUID"
msgstr "UUID"

#: src/modules/billing/payment_forms/labels.tsx
msgid "Valid thru"
msgstr "Berlaku hingga"

#: src/modules/billing/BillingAccountInfo.tsx
#: src/modules/dashboard/BillingAccounts.tsx
msgid "Validation pending"
msgstr "Validasi tertunda"

#: src/modules/compute/ParamsTextField.tsx
msgid "Value does not match required pattern"
msgstr "Nilai tidak sesuai dengan format yang diperlukan"

#: src/components/VatText.tsx
msgid "VAT"
msgstr "PPN"

#: src/components/VatText.tsx
msgid "VAT number"
msgstr "Nomor PPN"

#: src/modules/billing/LimitedBillingAccountNotice.tsx
#: src/modules/compute/MachineSizeInfo.tsx
#: src/modules/services/kubernetes/Infrastructure.tsx
#: src/modules/services/kubernetes/NodePoolsList.tsx
msgid "vCPU"
msgstr "vCPU"

#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "Verified"
msgstr "Terverifikasi"

#: src/modules/dashboard/BillingAccounts.tsx
msgid "Verified payment method is missing"
msgstr "Metode pembayaran terverifikasi tidak tersedia"

#: src/modules/billing/progressLabels.tsx
msgid "Verifying payment method"
msgstr "Memverifikasi metode pembayaran"

#: src/modules/compute/os/OsVersionSelect.tsx
#: src/modules/metal/os/MetalOsSelect.tsx
#: src/modules/services/os/OsVersionSelect.tsx
msgid "Version"
msgstr "Versi"

#. Button action
#: src/components/ResourceLink.tsx
#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/network/vpc/VpcView.tsx
#: src/modules/notifications/toast.tsx
#: src/modules/storage/account/StorageAccountView.tsx
#: src/modules/storage/account/StorageAccountView.tsx
#: src/modules/storage/account/StorageAccountView.tsx
#: src/modules/user/ProfileView.tsx
msgid "View"
msgstr "Lihat"

#: src/components/table/WTable.tsx
msgid "View all records"
msgstr "Lihat semua data"

#: src/modules/compute/VmView.tsx
msgid "View config commands"
msgstr "Lihat perintah konfigurasi"

#: src/modules/billing/BillingAccountNotices.tsx
#: src/modules/dashboard/BillingAccounts.tsx
msgid "View details"
msgstr "Lihat detail"

#: src/components/table/WTable.tsx
msgid "View last {limit} records"
msgstr "Lihat {limit} data terakhir"

#: src/modules/user/InvitationNotice.tsx
msgid "View more"
msgstr "Lihat selengkapnya"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Virtual host style URL"
msgstr "URL gaya virtual host"

#: src/modules/api/resourceTypes.tsx
msgid "Virtual machine"
msgstr "Mesin virtual"

#: src/modules/compute/SubInterfaceModal.tsx
msgid "VLAN"
msgstr "VLAN"

#: src/modules/compute/AddSubInterfaceModal.tsx
#: src/modules/compute/VmView.tsx
msgid "VLAN ID"
msgstr "ID VLAN"

#: src/modules/services/Networking.tsx
msgid "VPC IP range"
msgstr "Rentang IP VPC"

#: src/modules/compute/VmView.tsx
msgid "VPC name"
msgstr "Nama VPC"

#: src/modules/api/resourceTypes.tsx
#: src/modules/compute/AddSubInterfaceModal.tsx
#: src/modules/compute/VmCreate.tsx
#: src/modules/network/NetworkCreate.tsx
#: src/modules/network/VpcRow.tsx
#: src/modules/services/ConnectionDetails.tsx
#: src/modules/services/Networking.tsx
#: src/modules/services/ServiceCreate.tsx
msgid "VPC network"
msgstr "Jaringan VPC"

#: src/modules/network/NetworkCreate.tsx
msgid "VPC network is available at no additional cost."
msgstr "Jaringan VPC tersedia tanpa biaya tambahan."

#: src/modules/billing/BillingAccountInfo.tsx
msgid "Wait for verification or add card"
msgstr "Tunggu verifikasi atau tambahkan kartu"

#: src/modules/billing/progressLabels.tsx
msgid "Waiting for payment confirmation"
msgstr "Menunggu konfirmasi pembayaran"

#: src/modules/billing/popup/popup.ts
msgid "Waiting for popup to return from redirect timed out"
msgstr "Waktu tunggu popup untuk kembali setelah pengalihan telah habis"

#: src/modules/services/kubernetes/KubernetesStatusBadge.tsx
#: src/modules/services/ServicesList.tsx
msgid "Waking up"
msgstr "Sedang dibangunkan"

#: src/modules/access/AdminUserWarning.tsx
#: src/modules/compute/VmCreate.tsx
msgid "Warning"
msgstr "Peringatan"

#: src/modules/compute/DiskAddOrResizeModal.tsx
msgid "Warning: It is recommended to stop the virtual machine before resizing the boot disk."
msgstr "Peringatan: Disarankan untuk menghentikan mesin virtual sebelum mengubah ukuran disk boot."

#: src/modules/billing/choose_method/invoiceMethodLogic.tsx
msgid "We recommend adding a credit card while your request is being processed to activate services right away."
msgstr "Kami menyarankan untuk menambahkan kartu kredit selagi permintaan Anda sedang diproses agar layanan dapat segera diaktifkan."

#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "We recommend automated top up as it minimizes the risk of running out of funds and thus affecting your server resources."
msgstr "Kami merekomendasikan isi saldo otomatis karena meminimalkan risiko kehabisan dana dan dengan demikian memengaruhi sumber daya server Anda."

#: src/modules/dashboard/WelcomeBlock.tsx
msgid "We've assembled some links to get you started. Develop, test code, and deploy your applications in no time, from prototyping to large-scale development."
msgstr "Kami telah menyiapkan beberapa tautan untuk membantu Anda memulai. Kembangkan, uji kode, dan terapkan aplikasi Anda dengan cepat, mulai dari prototipe hingga pengembangan skala besar."

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "We've reached the capacity of our file browser. In order to maintain the stability of our user interface, we've terminated the loading of your bucket contents. Please utilize external tools at your disposal to manage the content within your bucket"
msgstr "Kami telah mencapai kapasitas browser file kami. Untuk menjaga stabilitas antarmuka pengguna, kami telah menghentikan pemuatan isi bucket Anda. Silakan gunakan alat eksternal yang tersedia untuk mengelola konten di dalam bucket Anda"

#: src/modules/dashboard/WelcomeBlock.tsx
msgid "Welcome"
msgstr "Selamat datang"

#: src/modules/dashboard/WelcomeModal.tsx
msgid "Welcome!<0/>We're glad you're here."
msgstr "Selamat datang!<0/>Kami senang Anda bergabung."

#: src/modules/network/DeleteWithFloatingIp.tsx
msgid "What would you like to do?"
msgstr "Apa yang ingin Anda lakukan?"

#: src/modules/billing/AutomatedTopUpModal.tsx
#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "When balance goes below"
msgstr "Saat saldo turun di bawah"

#: src/modules/network/ipAddress/IpAddressView.tsx
msgid "When reserved but not assigned to a resource IPv4 address will be charged for <0/> / month."
msgstr "Saat dicadangkan tetapi tidak ditetapkan ke resource, alamat IPv4 akan dikenakan biaya sebesar <0/> / bulan."

#: src/modules/network/CreateAndAssignIpField.tsx
msgid "When selected, a public floating IPv4 address will be created and assigned automatically to your resource. If you do not want to have public access to your resource you can unselect the option here or remove the IP address later."
msgstr "Jika dipilih, alamat Floating IP IPv4 publik akan dibuat dan ditetapkan secara otomatis ke sumber daya Anda. Jika Anda tidak ingin sumber daya Anda dapat diakses secara publik, Anda dapat membatalkan pilihan opsi ini di sini atau menghapus alamat IP tersebut nanti."

#: src/modules/compute/VmView.tsx
msgid "When you enable the backup service, an automatic disk-level backup will be created from the boot disk (excluding additional disks). A backup will be created once a week and will be listed here. You can later use the backup images to restore your virtual machine or create a new virtual machine with modified size parameters from the backup."
msgstr "Saat Anda mengaktifkan layanan backup, backup otomatis pada level disk akan dibuat dari disk boot (tidak termasuk disk tambahan). Backup akan dibuat seminggu sekali dan akan ditampilkan di sini. Anda nantinya dapat menggunakan image backup untuk memulihkan mesin virtual Anda atau membuat mesin virtual baru dengan parameter ukuran yang diubah dari backup tersebut."

#: src/components/loading/Loading.tsx
msgid "While the job is in progress you can:"
msgstr "Selama proses berjalan, Anda dapat:"

#: src/modules/api/resourceTypes.tsx
msgid "With a firewall you can control incoming and outgoing network traffic based on predetermined security rules."
msgstr "Dengan firewall, Anda dapat mengontrol lalu lintas jaringan masuk dan keluar berdasarkan aturan keamanan yang telah ditentukan."

#: src/modules/billing/firstAccountNotices.store.tsx
msgid "With first billing account you will be able to unlock your complimentary free credit of <0><1/></0>."
msgstr "Dengan akun penagihan pertama, Anda akan dapat membuka kredit gratis sebesar <0><1/></0>."

#. placeholder {0}: currency.title
#: src/modules/billing/ConversionMessage.tsx
msgid "With the selected payment method, you will be charged in {0}."
msgstr "Dengan metode pembayaran yang dipilih, Anda akan ditagih dalam {0}."

#: src/modules/dashboard/BillingAccounts.tsx
msgid "Without an active billing account you can not create any resources, create one to get started."
msgstr "Tanpa akun penagihan yang aktif, Anda tidak dapat membuat sumber daya apa pun. Buat akun terlebih dahulu untuk memulai."

#: src/modules/billing/BillingAccountNotices.tsx
msgid "Without an active billing account, resources can not be created."
msgstr "Tanpa akun penagihan yang aktif, sumber daya tidak dapat dibuat."

#. Time period unit
#: src/modules/metal/offer/period.tsx
msgid "year"
msgstr "tahun"

#. Server commitment period
#: src/modules/metal/offer/period.tsx
msgid "Yearly"
msgstr "Tahunan"

#: src/modules/disks/disk/DiskView.tsx
msgid "Yes"
msgstr "Ya"

#: src/modules/user/ActAsModal.tsx
msgid "You are about to access user \"{name}\""
msgstr "Anda akan mengakses pengguna \"{name}\""

#: src/modules/access/AdminUserWarning.tsx
msgid "You are an administrator and are about to delegate your administrative privileges to another user. Please ensure this action is intentional."
msgstr "Anda adalah administrator dan akan mendelegasikan hak istimewa administratif Anda kepada pengguna lain. Harap pastikan tindakan ini memang disengaja."

#: src/modules/user/ProfileView.tsx
msgid "You can activate multi-factor authentication for improved security. This works only for the username-password login method. For social login methods (Google etc.), it is usually possible to activate MFA on the third party side."
msgstr "Anda dapat mengaktifkan autentikasi multifaktor untuk meningkatkan keamanan. Fitur ini hanya berfungsi untuk metode masuk dengan nama pengguna dan kata sandi. Untuk metode masuk sosial (Google, dll.), biasanya MFA dapat diaktifkan di pihak ketiga."

#: src/modules/compute/BootFromIsoModal.tsx
msgid "You can boot your virtual machine from a special image for system recovery or to install a fresh operating system. When this mode is activated, a chosen image will be attached as a boot medium. You can then use the Terminal to access your machine. This boot mode is enabled only for the current launch. Next time this virtual machine is started it will follow the normal boot routine."
msgstr "Anda dapat melakukan boot mesin virtual dari image khusus untuk pemulihan sistem atau untuk memasang sistem operasi baru. Saat mode ini diaktifkan, image yang dipilih akan dilampirkan sebagai media boot. Setelah itu Anda dapat menggunakan Konsol untuk mengakses mesin Anda. Mode boot ini hanya diaktifkan untuk peluncuran saat ini. Saat mesin virtual ini dijalankan kembali nanti, proses boot normal akan digunakan."

#: src/modules/billing/PaymentReturn.tsx
msgid "You can close this page."
msgstr "Anda dapat menutup halaman ini."

#: src/modules/billing/billingAccount/BillingCreate.tsx
msgid "You can create multiple billing accounts, each linked to specific payment methods. This approach allows you to effectively separate and monitor expenses across different teams, departments, or projects."
msgstr "Anda dapat membuat beberapa akun penagihan, masing-masing terhubung ke metode pembayaran tertentu. Pendekatan ini memungkinkan Anda memisahkan dan memantau pengeluaran secara efektif di berbagai tim, departemen, atau proyek."

#: src/modules/billing/account_validation/digio/DigioBaValidationBlock.tsx
msgid "You can do this from here and continue it later by clicking the link in the email we send you."
msgstr "Anda dapat melakukannya dari sini dan melanjutkannya nanti dengan mengeklik tautan dalam email yang kami kirimkan kepada Anda."

#: src/modules/billing/referral/ReferralProgram.tsx
msgid "You can earn and give free credits by sharing your unique referral code."
msgstr "Anda dapat memperoleh dan memberikan kredit gratis dengan membagikan kode referral unik Anda."

#: src/modules/metal/commitment/AddCommitmentModal.tsx
msgid "You cannot add another reservation because a future reservation already exists."
msgstr "Anda tidak dapat menambahkan reservasi lain karena reservasi mendatang sudah ada."

#: src/modules/metal/offer/MetalOfferSection.tsx
msgid "You commit to the full price for the selected period as soon as you confirm the reservation."
msgstr "Anda berkomitmen untuk membayar harga penuh selama periode yang dipilih setelah mengonfirmasi reservasi."

#. placeholder {0}: ipAddress.address
#: src/modules/network/DeleteWithFloatingIp.tsx
msgid "You have a floating IP <0>{0}</0> assigned to this resource."
msgstr "Anda memiliki Floating IP <0>{0}</0> yang ditetapkan ke sumber daya ini."

#: src/modules/billing/firstAccountNotices.store.tsx
msgid "You have an active campaign code (<0>{referralCode}</0>) pending to get additional bonus!"
msgstr "Anda memiliki kode kampanye aktif (<0>{referralCode}</0>) yang menunggu untuk mendapatkan bonus tambahan!"

#: src/modules/billing/account_validation/digio/DigioBaValidationBlock.tsx
msgid "You have billing account validation in progress."
msgstr "Validasi akun penagihan Anda sedang berlangsung."

#: src/modules/billing/account_validation/digio/DigioBaValidationBlock.tsx
msgid "You have completed billing account validation process. Please wait for the final decision."
msgstr "Anda telah menyelesaikan proses validasi akun penagihan. Harap tunggu keputusan final."

#: src/modules/notifications/NotificationMenu.tsx
msgid "You have no notifications."
msgstr "Anda tidak memiliki notifikasi."

#: src/modules/billing/QrCodeDisplay.tsx
msgid "You may close this dialog after you have made a payment."
msgstr "Anda dapat menutup dialog ini setelah melakukan pembayaran."

#: src/modules/billing/payment/PaymentModal.tsx
msgid "You may close this dialog window for now."
msgstr "Anda dapat menutup jendela dialog ini untuk sementara."

#: src/modules/storage/bucket/BucketView.tsx
msgid "You need to have at least one access key for browsing files in this bucket."
msgstr "Anda harus memiliki setidaknya satu kunci akses untuk menelusuri file di bucket ini."

#: src/modules/billing/account_validation/GeneralBaValidationBlock.tsx
msgid "You will be able to set up payment methods and use cloud services once the validation is approved."
msgstr "Anda dapat menyiapkan metode pembayaran dan menggunakan layanan cloud setelah validasi disetujui."

#: src/modules/billing/NoValidBillingAccountNotice.tsx
msgid "You will be able to set up payment methods and use cloud services once the validation is complete."
msgstr "Anda dapat menyiapkan metode pembayaran dan menggunakan layanan cloud setelah validasi selesai."

#: src/modules/metal/MetalLeaseDetailView.tsx
msgid "You will not be charged until it is ready."
msgstr "Anda tidak akan dikenakan biaya sampai server siap."

#: src/modules/dashboard/BillingAccounts.tsx
msgid "Your account has been suspended"
msgstr "Akun Anda telah ditangguhkan"

#: src/modules/billing/ConversionMessage.tsx
msgid "Your actual charge will be <0/>, with exchange rate of <1/>."
msgstr "Biaya aktual Anda akan menjadi <0/>, dengan nilai tukar <1/>."

#: src/modules/billing/BillingAccountNotices.tsx
msgid "Your billing account has been suspended. See billing account details for more information and <0>contact support</0> to resolve the issue."
msgstr "Akun penagihan Anda telah ditangguhkan. Lihat detail akun penagihan untuk informasi lebih lanjut dan <0>hubungi dukungan</0> untuk menyelesaikan masalah ini."

#: src/modules/billing/payment/PaymentModal.tsx
msgid "Your billing account has been topped up"
msgstr "Akun penagihan Anda telah diisi saldo"

#: src/modules/billing/BillingAccountNotices.tsx
msgid "Your billing account must have positive balance to get activated."
msgstr "Akun penagihan Anda harus memiliki saldo positif agar dapat diaktifkan."

#: src/modules/login/Login.tsx
msgid "Your email address has been successfully verified. You can now log in."
msgstr "Alamat email Anda berhasil diverifikasi. Anda sekarang dapat masuk."

#: src/modules/billing/account_validation/digio/DigioBaValidationBlock.tsx
msgid "Your email address has changed since you started validation. Please start over."
msgstr "Alamat email Anda telah berubah sejak Anda memulai validasi. Silakan mulai lagi."

#: src/modules/billing/BillingDiscountNotice.tsx
msgid "Your selected billing account has {discount}% discount"
msgstr "Akun penagihan yang Anda pilih memiliki diskon {discount}%"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Your storage bucket contains a substantial number of files, and we've temporarily halted the loading process. Simply click the \"Load More\" button to continue loading the next batch of files."
msgstr "Bucket penyimpanan Anda berisi sangat banyak file, dan kami telah menghentikan sementara proses pemuatan. Cukup klik tombol \"Muat lebih banyak\" untuk melanjutkan memuat kumpulan file berikutnya."

#: src/modules/billing/billingAccount/fieldsInfo.tsx
msgid "Zip/postal code"
msgstr "Kode pos"
